/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import { Random } from "random-js";
import Handlebars from 'handlebars';
import axios from '@/axios.js'
import con from '@/firebase/firebaseInit.ts'
import firebase from 'firebase';
import ls from "@/common/localStorage"
import moment from "moment-timezone";

//const cn = 'OA_UAT_C1591205467009E1591206650065'
var cn = ls.getSessionEventCollectionName();
var eventRef = (cn ? con.eventDB.collection(cn).doc('EventInfo') : null)
var storageRef = con.storageRef
var ClientCollectionName = 'OA_UAT';
var Session_Client_Id = ls.getSessionValueByKey("Session_Client_Id")
var Session_Event_Id = ls.getSessionValueByKey("Session_Event_Id")
var Session_UserId = ls.getSessionValueByKey("UserId")
var userEventsRef = Session_Client_Id ? con.instanceDB.doc("ClientList").collection("Clients").doc(Session_Client_Id).collection('UserEvents') : null;
var EventAdminRef = Session_Client_Id ? con.instanceDB.doc("ClientList").collection("Clients").doc(Session_Client_Id).collection('Events') : null;
var clientRef = con.eventDB.collection(ClientCollectionName).doc("ClientList").collection("Clients");
var SINGLEEMAILAPIURL = con.SINGLEEMAILAPIURL;
var FirebaseAuthApi = con.FirebaseAuthApi;
var CloneEventAPI = con.CloneEventAPI
var CreateEventAPI = con.CreateEventAPI
var CheckUserValidAPI = con.CheckUserValidAPI;
var UpdateUserAPI = con.UpdateUserAPI;
var AddSingleAttendeeAPI = con.AddSingleAttendeeAPI;
var DeleteAttendeeApiKey = con.DeleteAttendeeApiKey;
var UserEventsAPI = con.UserEventsAPI;
var getJoinURLAPI = con.getJoinURLAPI;
export default {
    reInitEventSession() {
        cn = ls.getSessionEventCollectionName();
        eventRef = (cn ? con.eventDB.collection(cn).doc('EventInfo') : null)
        storageRef = con.storageRef
        ClientCollectionName = 'OA_UAT';
        Session_Client_Id = ls.getSessionValueByKey("Session_Client_Id")
        Session_UserId = ls.getSessionValueByKey("UserId")
        userEventsRef = con.instanceDB.doc("ClientList").collection("Clients").doc(Session_Client_Id).collection('UserEvents');
        clientRef = con.eventDB.collection(ClientCollectionName).doc("ClientList").collection("Clients");
    },
    fetchEvents({ commit }) {
        return new Promise((resolve, reject) => {
            const markers = []
            eventRef.get().then(querySnapshot => {
                querySnapshot.docs.forEach(doc => {
                    markers.push(doc.data())
                })
                commit('SET_EVENTS', markers)
                resolve(markers)
            }).catch(function (error) {
                //console.log('Error getting attendee:', error)
                reject(error)
            })

        })
    },
    fetchEvent(context, id) {
        //console.log(id)
        return new Promise((resolve, reject) => {
            if (id === null) {
                resolve({
                    status: 200,
                    data: {
                        AllowRegistration: false,
                        ExternalRegistrationEnabled: false,
                        ExternalRegistrationLink: null,
                        AttendeeCount: 0,
                        BackgroundColor: '',
                        BackgroundImage: '',
                        ClientCollectionName: ClientCollectionName,
                        ClientId: '',
                        CreatedTime: new Date(),
                        DateFormat: 'dd MMM yyyy',
                        E2MEventId: 0,
                        EventBanner: '',
                        EventCode: 0,
                        EventCollectionName: '',
                        EventEndDate: '',
                        EventFullName: '',
                        EventSlug: '',
                        EventId: '',
                        EventLogo: '',
                        EventShortName: '',
                        EventStartDate: '',
                        IsPublished: true,
                        postToCRM: false,
                        HideEventHeaderAndMenu: false,
                        EnableEmailOnlyLogin: false,
                        AllowPublicAccess: false,
                        RegistrationVersion: 1,
                        ShowProfileEditOnWelcome: false,
                        AllowProfileEdit: false,
                        showAttendeePresenceBubble: false,
                        WelcomeMessage: null,
                        DisableLanguageOption: false,
                        LogoutRedirectURL: null,
                        EventTypeId: 1,
                        ExhibitorCount: 0,
                        LobbyType: 1,
                        ModifiedTime: new Date(),
                        RoundTableCount: 0,
                        SessionCount: 0,
                        SpeakerCount: 0,
                        SponsorCount: 0,
                        TimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                        UseBackgroundImage: true,

                        EventType: 1,
                        Description: '',
                        LocationType: { Id: 2, Name: "Virtual" },
                        Venue: '',
                        DefaultLandingURL: '/lobby',
                        StartDate: null,
                        EndDate: null,
                        EventAccessType: 'Unique Passcode per Attendee',
                        defaultEP: null,
                        StreamingClient: 'Zoom',
                        approval_type: 0,
                        MetaTitle: null,
                        MetaDescription: null,
                        MetaKeywords: null,
                        MetaImage: null
                    }
                })
            } else {
                let docObj = new Object
                eventRef.get().then(function (doc) {
                    docObj = doc.data();
                    docObj.RegistrationVersion = docObj.RegistrationVersion == undefined ? 1 : docObj.RegistrationVersion;
                    docObj.AllowRegistration = docObj.AllowRegistration == undefined ? false : docObj.AllowRegistration;
                    docObj.ExternalRegistrationEnabled = docObj.ExternalRegistrationEnabled == undefined ? false : docObj.ExternalRegistrationEnabled;
                    docObj.ExternalRegistrationLink = docObj.ExternalRegistrationLink == undefined ? null : docObj.ExternalRegistrationLink;
                    docObj.EventStartDate = new Date(doc.data().EventStartDate.seconds * 1000).toUTCString();
                    docObj.EventEndDate = new Date(doc.data().EventEndDate.seconds * 1000).toUTCString();
                    docObj.StartDate = null;
                    docObj.EndDate = null;
                    docObj.EventType = (doc.data().EventTypeId ? doc.data().EventTypeId : 1);
                    docObj.LocationType = (doc.data().LocationType ? doc.data().LocationType : { Id: 2, Name: "Virtual" });
                    docObj.DefaultLandingURL = doc.data().DefaultLandingURL;
                    docObj.EventAccessType = doc.data().EventAccessType ? doc.data().EventAccessType : 'Unique Passcode per Attendee';
                    docObj.defaultEP = doc.data().defaultEP ? atob(doc.data().defaultEP) : null;
                    docObj.StreamingClient = doc.data().StreamingClient ? doc.data().StreamingClient : 'Zoom';
                    docObj.approval_type = doc.data().approval_type != undefined ? doc.data().approval_type : 0;
                    docObj.MetaTitle = doc.data().MetaTitle ? doc.data().MetaTitle : null;
                    docObj.MetaDescription = doc.data().MetaDescription ? doc.data().MetaDescription : null;
                    docObj.MetaKeywords = doc.data().MetaKeywords ? doc.data().MetaKeywords : null;
                    docObj.MetaImage = doc.data().MetaImage ? doc.data().MetaImage : null;
                    //console.log(docObj)                   
                    if (docObj.DefaultLandingURL === undefined || docObj.DefaultLandingURL == null || docObj.DefaultLandingURL == "") {
                        docObj.DefaultLandingURL = '/lobby';
                    }

                    resolve({ status: 200, data: docObj })
                }).catch(function (error) {
                    console.log('Error getting mapped attendee:', error)
                    reject(error)
                })
            }

        })
    },
    updateEvent(context, field) {
        return new Promise(async(resolve, reject) => {            
            let docObj = {
                //ClientId: ls.getSessionValueByKey("Session_Client_Id"),
                //EventCollectionName: ls.getSessionEventCollectionName(),
                //EventEndDate: new Date(field.data.EventEndDate),
                //EventStartDate: new Date(field.data.EventStartDate),
                AllowRegistration: field.data.AllowRegistration == undefined ? false : field.data.AllowRegistration,
                ExternalRegistrationEnabled: field.data.AllowRegistration && field.data.ExternalRegistrationEnabled ? true : false,
                ExternalRegistrationLink: field.data.ExternalRegistrationLink ? field.data.ExternalRegistrationLink : null,
                EventStartDate: (field.data.StartDate ? field.data.StartDate : null),
                EventEndDate: (field.data.EndDate ? field.data.EndDate : null),
                EventFullName: field.data.EventFullName.trim(),
                EventShortName: field.data.EventFullName.trim(),
                EventTypeId: parseInt(field.data.EventType),
                ModifiedTime: new Date(),
                UseBackgroundImage: field.data.UseBackgroundImage,
                TimeZone: field.data.TimeZone,
                Description: (field.data.Description ? field.data.Description : ''),

                BackgroundColor: field.data.BackgroundColor ? field.data.BackgroundColor : '',
                BodyTextColor: field.data.BodyTextColor ? field.data.BodyTextColor : '',
                EventLogo: (field.data.EventLogo ? field.data.EventLogo : ''),
                BackgroundImage: (field.data.BackgroundImage ? field.data.BackgroundImage : ''),
                EventBanner: (field.data.EventBanner ? field.data.EventBanner : ''),
                EventBannerMobile: (field.data.EventBannerMobile ? field.data.EventBannerMobile : ''),
                EventBannerShare: (field.data.EventBannerShare ? field.data.EventBannerShare : ''),

                LocationType: (field.data.LocationType ? field.data.LocationType : { Id: 2, Name: "Virtual" }),
                Venue: (field.data.Venue ? field.data.Venue : ''),
                DefaultLandingURL: (field.data.DefaultLandingURL ? field.data.DefaultLandingURL : '/lobby'),
                EventAccessType: (field.data.EventAccessType ? field.data.EventAccessType : 'Unique Passcode per Attendee'),
                defaultEP: (field.data.EventAccessType == 'Use Common Event Passcode' && field.data.defaultEP ? btoa(field.data.defaultEP) : null),
                postToCRM: field.data.postToCRM ? true : false,
                HideEventHeaderAndMenu: field.data.HideEventHeaderAndMenu ? true : false,
                EnableEmailOnlyLogin: field.data.EnableEmailOnlyLogin ? true : false,
                AllowPublicAccess: field.data.AllowPublicAccess ? true : false,
                RegistrationVersion: field.data.RegistrationVersion ? field.data.RegistrationVersion : 1,
                ShowProfileEditOnWelcome: field.data.ShowProfileEditOnWelcome ? true : false,
                AllowProfileEdit: field.data.AllowProfileEdit ? true : false,
                showAttendeePresenceBubble: field.data.showAttendeePresenceBubble ? true : false,
                WelcomeMessage: field.data.WelcomeMessage ? field.data.WelcomeMessage : null,
                DisableLanguageOption: field.data.DisableLanguageOption ? true : false,
                LogoutRedirectURL: field.data.LogoutRedirectURL ? field.data.LogoutRedirectURL : null,
                StreamingClient: field.data.StreamingClient ? field.data.StreamingClient : 'Zoom',
                approval_type: field.data.approval_type,
                DefaultLanguage: field.data.DefaultLanguage != null ? field.data.DefaultLanguage : 'English',
                MetaTitle: field.data.MetaTitle,
                MetaDescription: field.data.MetaDescription,
                MetaKeywords: field.data.MetaKeywords,
                MetaImage: field.data.MetaImage
            };

            if (docObj.EventLogo == "") {
                if (field.brandingJson.eventLogo != undefined) {
                    if (field.brandingJson.eventLogo["960x192"] != undefined) {
                        docObj.EventLogo = field.brandingJson.eventLogo["960x192"];
                    }
                }
            }
            if (docObj.BackgroundImage == "") {
                if (field.brandingJson.eventBGImage != undefined) {
                    if (field.brandingJson.eventBGImage["2732x2048"] != undefined) {
                        docObj.BackgroundImage = field.brandingJson.eventBGImage["2732x2048"];
                    }
                }
            }
            if (docObj.BodyTextColor == "") {
                if (field.brandingJson.bodyTextColor != undefined) {
                    if (field.brandingJson.bodyTextColor != undefined) {
                        docObj.BodyTextColor = field.brandingJson.bodyTextColor;
                    }
                }
            }
            if (docObj.EventBanner == "") {
                if (field.brandingJson.banner != undefined) {
                    if (field.brandingJson.banner["2048x88"] != undefined) {
                        docObj.EventBanner = field.brandingJson.banner["2048x88"];
                    }
                }
            }
            context.dispatch('uploadBrandingJsonHexCodeType', { brandingJson: field.brandingJson, EventInfo: docObj });
            var theme = "light";
            if (field.brandingJson.appColorHexCodeType == 'headerColorsHexCodeLight') {
                theme = "light"
            } else if (field.brandingJson.appColorHexCodeType == 'headerColorsHexCodeDark') {
                theme = "dark";
            }
            context.dispatch('updateEventMenuTheme', theme);

            var customDomain = ls.getSessionValueByKey("CustomDomain");
            if (customDomain != null) {
                customDomain = "https://" + ls.getSessionValueByKey("CustomDomain");
            } else {
                customDomain = "";
            }

            con.eventDB.collection(cn).doc("mailtpl").collection("welcomeMail").doc('UserSignup').get().then(function (eventTemplate) {
                if (eventTemplate.exists) {
                    var bodyHtml = eventTemplate.data().htmlRaw == undefined ? eventTemplate.data().html : eventTemplate.data().htmlRaw;
                    bodyHtml = bodyHtml.replace("{{StartDate}}", field.data.StartDateTZ);
                    bodyHtml = bodyHtml.replace("{{StartTime}}", field.data.StartTimeTZ);
                    bodyHtml = bodyHtml.replace("{{EndDate}}", field.data.EndDateTZ);
                    bodyHtml = bodyHtml.replace("{{EndTime}}", field.data.EndTimeTZ);
                    bodyHtml = bodyHtml.replace("{{TimeZone}}", field.data.TimeZone);
                    bodyHtml = bodyHtml.replace("{{CustomDomain}}", customDomain);
                    bodyHtml = bodyHtml.replace("{{CustomDomain}}", customDomain);
                    con.eventDB.collection(cn).doc("mailtpl").collection("welcomeMail").doc('UserSignup').update({ html: bodyHtml })
                } else {
                    con.instanceDB.doc("mailtpl").collection("welcomeMail").doc('UserSignup').get().then(function (mailtpl) {
                        if (mailtpl.exists) {
                            var bodyHtml = mailtpl.data().htmlRaw == undefined ? mailtpl.data().html : mailtpl.data().htmlRaw;
                            bodyHtml = bodyHtml.replace("{{StartDate}}", field.data.StartDateTZ);
                            bodyHtml = bodyHtml.replace("{{StartTime}}", field.data.StartTimeTZ);
                            bodyHtml = bodyHtml.replace("{{EndDate}}", field.data.EndDateTZ);
                            bodyHtml = bodyHtml.replace("{{EndTime}}", field.data.EndTimeTZ);
                            bodyHtml = bodyHtml.replace("{{TimeZone}}", field.data.TimeZone);
                            bodyHtml = bodyHtml.replace("{{CustomDomain}}", customDomain);
                            bodyHtml = bodyHtml.replace("{{CustomDomain}}", customDomain);
                            con.eventDB.collection(docObj.EventCollectionName).doc("mailtpl").collection("welcomeMail").doc('UserSignup').set({ html: bodyHtml })
                        } else {
                            con.eventDB.collection(docObj.EventCollectionName).doc("mailtpl").collection("welcomeMail").doc('UserSignup').set({ html: '', htmlRaw: '', subject: '' })
                        }
                    })
                }
            })

            con.eventDB.collection(cn).doc("mailtpl").collection("ReminderMail").doc('Reminder').get().then(function (eventTemplate) {
                if (eventTemplate.exists) {
                    var bodyHtml = eventTemplate.data().htmlRaw == undefined ? eventTemplate.data().html : eventTemplate.data().htmlRaw;
                    bodyHtml = bodyHtml.replace("{{StartDate}}", field.data.StartDateTZ);
                    bodyHtml = bodyHtml.replace("{{StartTime}}", field.data.StartTimeTZ);
                    bodyHtml = bodyHtml.replace("{{EndDate}}", field.data.EndDateTZ);
                    bodyHtml = bodyHtml.replace("{{EndTime}}", field.data.EndTimeTZ);
                    bodyHtml = bodyHtml.replace("{{TimeZone}}", field.data.TimeZone);
                    bodyHtml = bodyHtml.replace("{{CustomDomain}}", customDomain);
                    bodyHtml = bodyHtml.replace("{{CustomDomain}}", customDomain);
                    con.eventDB.collection(cn).doc("mailtpl").collection("ReminderMail").doc('Reminder').update({ html: bodyHtml })
                } else {
                    con.instanceDB.doc("mailtpl").collection("ReminderMail").doc('Reminder').get().then(function (mailtpl) {
                        if (mailtpl.exists) {
                            var bodyHtml = mailtpl.data().htmlRaw == undefined ? mailtpl.data().html : mailtpl.data().htmlRaw;
                            bodyHtml = bodyHtml.replace("{{StartDate}}", field.data.StartDateTZ);
                            bodyHtml = bodyHtml.replace("{{StartTime}}", field.data.StartTimeTZ);
                            bodyHtml = bodyHtml.replace("{{EndDate}}", field.data.EndDateTZ);
                            bodyHtml = bodyHtml.replace("{{EndTime}}", field.data.EndTimeTZ);
                            bodyHtml = bodyHtml.replace("{{TimeZone}}", field.data.TimeZone);
                            bodyHtml = bodyHtml.replace("{{CustomDomain}}", customDomain);
                            bodyHtml = bodyHtml.replace("{{CustomDomain}}", customDomain);
                            con.eventDB.collection(docObj.EventCollectionName).doc("mailtpl").collection("ReminderMail").doc('Reminder').set({ html: bodyHtml })
                        } else {
                            con.eventDB.collection(docObj.EventCollectionName).doc("mailtpl").collection("ReminderMail").doc('Reminder').set({ html: '', htmlRaw: '', subject: '' })
                        }
                    })
                }
            })
            con.eventDB.collection(cn).doc("mailtpl").collection("AnnouncementMail").doc('Announcement').get().then(function (eventTemplate) {
                if (eventTemplate.exists) {
                    var bodyHtml = eventTemplate.data().htmlRaw == undefined ? eventTemplate.data().html : eventTemplate.data().htmlRaw;
                    bodyHtml = bodyHtml.replace("{{StartDate}}", field.data.StartDateTZ);
                    bodyHtml = bodyHtml.replace("{{StartTime}}", field.data.StartTimeTZ);
                    bodyHtml = bodyHtml.replace("{{EndDate}}", field.data.EndDateTZ);
                    bodyHtml = bodyHtml.replace("{{EndTime}}", field.data.EndTimeTZ);
                    bodyHtml = bodyHtml.replace("{{TimeZone}}", field.data.TimeZone);
                    bodyHtml = bodyHtml.replace("{{CustomDomain}}", customDomain);
                    bodyHtml = bodyHtml.replace("{{CustomDomain}}", customDomain);
                    con.eventDB.collection(cn).doc("mailtpl").collection("AnnouncementMail").doc('Announcement').update({ html: bodyHtml })
                } else {
                    con.instanceDB.doc("mailtpl").collection("AnnouncementMail").doc('Announcement').get().then(function (mailtpl) {
                        if (mailtpl.exists) {
                            var bodyHtml = mailtpl.data().htmlRaw == undefined ? mailtpl.data().html : mailtpl.data().htmlRaw;
                            bodyHtml = bodyHtml.replace("{{StartDate}}", field.data.StartDateTZ);
                            bodyHtml = bodyHtml.replace("{{StartTime}}", field.data.StartTimeTZ);
                            bodyHtml = bodyHtml.replace("{{EndDate}}", field.data.EndDateTZ);
                            bodyHtml = bodyHtml.replace("{{EndTime}}", field.data.EndTimeTZ);
                            bodyHtml = bodyHtml.replace("{{TimeZone}}", field.data.TimeZone);
                            bodyHtml = bodyHtml.replace("{{CustomDomain}}", customDomain);
                            bodyHtml = bodyHtml.replace("{{CustomDomain}}", customDomain);
                            con.eventDB.collection(docObj.EventCollectionName).doc("mailtpl").collection("AnnouncementMail").doc('Announcement').set({ html: bodyHtml })
                        } else {
                            con.eventDB.collection(docObj.EventCollectionName).doc("mailtpl").collection("AnnouncementMail").doc('Announcement').set({ html: '', htmlRaw: '', subject: '' })
                        }
                    })
                }
            })

            if(field.data.AllowRegistration){
                con.instanceDB.doc('ClientList').collection('Clients').doc(Session_Client_Id).update({AllowRegister: true}).then(function(){
                    context.dispatch('clientManagement/updateCluentBrandingJSON', Session_Client_Id, {root:true})
                })
            }else if(field.data.AllowRegistration == false){                
                let snaps = await con.instanceDB.doc('ClientList').collection('Clients').doc(Session_Client_Id).collection('Events').where('AllowRegister', '==', true).get();
                let AllowRegister = snaps.docs && snaps.docs.length ? true : false;
                con.instanceDB.doc('ClientList').collection('Clients').doc(Session_Client_Id).update({AllowRegister: AllowRegister}).then(function(){
                    context.dispatch('clientManagement/updateCluentBrandingJSON', Session_Client_Id, {root:true})
                })
            }

            con.eventDB.collection(cn).doc('EventInfo').update(docObj).then(function () {
                con.instanceDB.doc('ClientList').collection('Clients').doc(Session_Client_Id).collection('Events').doc(field.id).update(docObj).then(function () {
                    resolve({ status: 200, message: 'Event Updated.' })
                })
            })

        })
    },
    updateEventField(context, field){
        let docObj = field.data;
        return new Promise((resolve, reject) => {
            con.eventDB.collection(cn).doc('EventInfo').update(docObj).then(function () {
                con.instanceDB.doc('ClientList').collection('Clients').doc(Session_Client_Id).collection('Events').doc(Session_Event_Id).update(docObj).then(function () {
                    resolve({ status: 200, message: 'Event Updated.' })
                })
            })
        })
    },
    changeStatus(context, field) {
        return new Promise((resolve, reject) => {   
            let docObj = {
                IsPublished: field.IsPublished
            };        

            con.eventDB.collection(cn).doc('EventInfo').update(docObj).then(function () {
                con.instanceDB.doc('ClientList').collection('Clients').doc(Session_Client_Id).collection('Events').doc(field.id).update(docObj).then(function () {
                    resolve({ status: 200, message: 'Event Updated.' })
                })
            })

        })
    },
    addEvent(context, field) {
        return new Promise((resolve, reject) => {
            let AutoID = "E" + new Date().getTime();
            let docObj = {
                AllowRegistration: field.data.AllowRegistration == undefined ? false : field.data.AllowRegistration,
                ExternalRegistrationEnabled: field.data.AllowRegistration && field.data.ExternalRegistrationEnabled ? true : false,
                ExternalRegistrationLink: field.data.ExternalRegistrationLink ? field.data.ExternalRegistrationLink : null,
                EventCollectionName: ClientCollectionName + '_' + Session_Client_Id + AutoID,
                EventId: AutoID,
                TimeZone: field.data.TimeZone,
                AttendeeCount: 0,
                BackgroundColor: '',
                ClientCollectionName: ClientCollectionName,
                ClientId: Session_Client_Id,
                CreatedTime: new Date(),
                DateFormat: 'dd MMM yyyy',
                E2MEventId: 0,
                EventCode: 0,
                //EventStartDate: new Date(field.data.EventStartDate),
                //EventEndDate: new Date(field.data.EventEndDate),
                EventStartDate: (field.data.StartDate ? field.data.StartDate : null),
                EventEndDate: (field.data.EndDate ? field.data.EndDate : null),
                EventFullName: field.data.EventFullName.trim(),
                EventShortName: field.data.EventFullName.trim(),
                IsPublished: false,
                EventTypeId: parseInt(field.data.EventType),
                ExhibitorCount: 0,
                LobbyType: 1,
                ModifiedTime: new Date(),
                RoundTableCount: 0,
                SessionCount: 0,
                SpeakerCount: 0,
                SponsorCount: 0,
                UseBackgroundImage: false,

                //EventType: field.data.EventType,
                Description: field.data.Description,
                LocationType: (field.data.LocationType ? field.data.LocationType : { Id: 2, Name: "Virtual" }),
                Venue: field.data.Venue,
                DefaultLandingURL: field.data.DefaultLandingURL,
                //defaultEP: "I215ZXZlbnQzMjE="
                EventAccessType: (field.data.EventAccessType ? field.data.EventAccessType : 'Unique Passcode per Attendee'),
                defaultEP: (field.data.EventAccessType == 'Use Common Event Passcode' && field.data.defaultEP ? field.data.defaultEP : null),
                postToCRM: field.data.postToCRM ? true : false,
                HideEventHeaderAndMenu: field.data.HideEventHeaderAndMenu ? true : false,
                EnableEmailOnlyLogin: field.data.EnableEmailOnlyLogin ? true : false,
                AllowPublicAccess: field.data.AllowPublicAccess ? true : false,
                RegistrationVersion: field.data.RegistrationVersion ? field.data.RegistrationVersion : 1,
                ShowProfileEditOnWelcome: field.data.ShowProfileEditOnWelcome ? true : false,
                AllowProfileEdit: field.data.AllowProfileEdit ? true : false,
                showAttendeePresenceBubble: field.data.showAttendeePresenceBubble ? true : false,
                WelcomeMessage: field.data.WelcomeMessage ? field.data.WelcomeMessage : null,
                DisableLanguageOption: field.data.DisableLanguageOption ? true : false,
                LogoutRedirectURL: field.data.LogoutRedirectURL ? field.data.LogoutRedirectURL : null,
                StreamingClient: field.data.StreamingClient ? field.data.StreamingClient : 'Zoom',
                DefaultLanguage: field.data.DefaultLanguage != null ? field.data.DefaultLanguage : 'English'
            };
            if (docObj.DefaultLandingURL === undefined || docObj.DefaultLandingURL === null || docObj.DefaultLandingURL === "") {
                docObj.DefaultLandingURL = '/lobby';
            }
            context.dispatch('uploadImage', { path: docObj.EventCollectionName + '/Branding/', file: field.data.EventLogoFile }).then(EventLogoUrl => {
                context.dispatch('uploadImage', { path: docObj.EventCollectionName + '/Branding/', file: field.data.BackgroundImageFile }).then(BackgroundImageUrl => {
                    context.dispatch('uploadImage', { path: docObj.EventCollectionName + '/Branding/', file: field.data.EventBannerFile }).then(EventBannerUrl => {
                        docObj.EventLogo = EventLogoUrl && EventLogoUrl != "" ? EventLogoUrl : "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2F960X192_white.jpg?alt=media"
                        docObj.BackgroundImage = BackgroundImageUrl && BackgroundImageUrl != "" ? BackgroundImageUrl : "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2FLogin_screen_2732X2048_white.jpg?alt=media"
                        docObj.EventBanner = EventBannerUrl && EventBannerUrl != "" ? EventBannerUrl : "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2FBanner_2048X88_white.jpg?alt=media"
                        con.eventDB.collection(docObj.EventCollectionName).doc('EventInfo').set(docObj).then(function () {
                            context.dispatch('getUserDetailbyId', `${Session_UserId}`).then(userDoc => {
                                if (userDoc.userStatus) {
                                    var userData = userDoc;
                                    let attendeObj = {
                                        AttendeeId: userData.UserId,
                                        Name: userData.Name,
                                        FirstName: userData.FirstName,
                                        LastName: userData.LastName,
                                        Email: userData.Email,
                                        Password: userData.Password,
                                        Phone: userData.Phone,
                                        Country: '',
                                        Company: userData.Company,
                                        Designation: userData.Designation,
                                        Profile: '',
                                        ProfilePictureURL: userData.ProfilePictureURL,
                                        Website: '',
                                        SocialLinks: [
                                            { Facebook: '' },
                                            { GooglePlus: '' },
                                            { LinkedIn: '' },
                                            { Twitter: '' }
                                        ],
                                        Tags: '',
                                        MailSent: false,
                                        IsVerified: true,
                                        IsPublished: true,
                                        UserRoles: [{
                                            RoleID: 10,
                                            RoleName: "AppUser"
                                        }],
                                        CreatedDate: new Date(),
                                        LastModifiedDate: new Date()
                                    }

                                    con.eventDB.collection(docObj.EventCollectionName).doc('AttendeeList').set({}).then(function () {
                                        con.eventDB.collection(docObj.EventCollectionName).doc('AttendeeList').collection("Attendees").doc(`${userData.UserId}`).set(attendeObj).then(function () {
                                            userEventsRef.doc(userData.UserId).get().then(function (userEvent) {
                                                //userEventsRef.where("UserId", "==", userData.UserId).get().then(function(userEvent) {
                                                if (!userEvent.exists) {
                                                    //if (userEvent.docs.length == 0) {
                                                    userEventsRef.doc(userData.UserId).set({
                                                        UserId: userData.UserId,
                                                        EventIDs: [AutoID],
                                                        LastModifiedDate: new Date()
                                                    })
                                                } else {
                                                    userEventsRef.doc(userData.UserId).update({
                                                        EventIDs: firebase.firestore.FieldValue.arrayUnion(AutoID),
                                                        LastModifiedDate: new Date()
                                                    })
                                                }
                                            })
                                        });
                                    })
                                }
                            });

                            context.dispatch('setVirtuallobby', docObj);

                            var customDomain = ls.getSessionValueByKey("CustomDomain");
                            if (customDomain != null) {
                                customDomain = "https://" + ls.getSessionValueByKey("CustomDomain");
                            } else {
                                customDomain = "";
                            }
                            con.instanceDB.doc("mailtpl").collection("welcomeMail").doc('UserSignup').get().then(function (mailtpl) {
                                if (mailtpl.exists) {
                                    var bodyHtml = mailtpl.data().html;
                                    bodyHtml = bodyHtml.replace("{{StartDate}}", field.data.StartDateTZ);
                                    bodyHtml = bodyHtml.replace("{{StartTime}}", field.data.StartTimeTZ);
                                    bodyHtml = bodyHtml.replace("{{EndDate}}", field.data.EndDateTZ);
                                    bodyHtml = bodyHtml.replace("{{EndTime}}", field.data.EndTimeTZ);
                                    bodyHtml = bodyHtml.replace("{{TimeZone}}", field.data.TimeZone);
                                    bodyHtml = bodyHtml.replace("{{CustomDomain}}", customDomain);
                                    bodyHtml = bodyHtml.replace("{{CustomDomain}}", customDomain);
                                    con.eventDB.collection(docObj.EventCollectionName).doc("mailtpl").collection("welcomeMail").doc('UserSignup').set({ designJson: mailtpl.data().designJson,html: bodyHtml, htmlRaw: mailtpl.data().html, subject: mailtpl.data().subject })
                                } else {
                                    con.eventDB.collection(docObj.EventCollectionName).doc("mailtpl").collection("welcomeMail").doc('UserSignup').set({ designJson: '',html: '', htmlRaw: '', subject: '' })
                                }
                            })

                            con.instanceDB.doc("mailtpl").collection("ReminderMail").doc('Reminder').get().then(function (mailtpl) {
                                if (mailtpl.exists) {
                                    var bodyHtml = mailtpl.data().html;
                                    bodyHtml = bodyHtml.replace("{{StartDate}}", field.data.StartDateTZ);
                                    bodyHtml = bodyHtml.replace("{{StartTime}}", field.data.StartTimeTZ);
                                    bodyHtml = bodyHtml.replace("{{EndDate}}", field.data.EndDateTZ);
                                    bodyHtml = bodyHtml.replace("{{EndTime}}", field.data.EndTimeTZ);
                                    bodyHtml = bodyHtml.replace("{{TimeZone}}", field.data.TimeZone);
                                    bodyHtml = bodyHtml.replace("{{CustomDomain}}", customDomain);
                                    bodyHtml = bodyHtml.replace("{{CustomDomain}}", customDomain);
                                    con.eventDB.collection(docObj.EventCollectionName).doc("mailtpl").collection("ReminderMail").doc('Reminder').set({ designJson: mailtpl.data().designJson,html: bodyHtml, htmlRaw: mailtpl.data().html, subject: mailtpl.data().subject })
                                } else {
                                    con.eventDB.collection(docObj.EventCollectionName).doc("mailtpl").collection("ReminderMail").doc('Reminder').set({ designJson: '',html: '', htmlRaw: '', subject: '' })
                                }
                            })
                            
                            con.instanceDB.doc("mailtpl").collection("AnnouncementMail").doc('Announcement').get().then(function (mailtpl) {
                                if (mailtpl.exists) {
                                    var bodyHtml = mailtpl.data().html;
                                    bodyHtml = bodyHtml.replace("{{StartDate}}", field.data.StartDateTZ);
                                    bodyHtml = bodyHtml.replace("{{StartTime}}", field.data.StartTimeTZ);
                                    bodyHtml = bodyHtml.replace("{{EndDate}}", field.data.EndDateTZ);
                                    bodyHtml = bodyHtml.replace("{{EndTime}}", field.data.EndTimeTZ);
                                    bodyHtml = bodyHtml.replace("{{TimeZone}}", field.data.TimeZone);
                                    bodyHtml = bodyHtml.replace("{{CustomDomain}}", customDomain);
                                    bodyHtml = bodyHtml.replace("{{CustomDomain}}", customDomain);
                                    con.eventDB.collection(docObj.EventCollectionName).doc("mailtpl").collection("AnnouncementMail").doc('Announcement').set({ designJson: mailtpl.data().designJson,html: bodyHtml, htmlRaw: mailtpl.data().html, subject: mailtpl.data().subject })
                                } else {
                                    con.eventDB.collection(docObj.EventCollectionName).doc("mailtpl").collection("AnnouncementMail").doc('Announcement').set({ designJson: '',html: '', htmlRaw: '', subject: '' })
                                }
                            })

                            con.instanceDB.doc("mailtpl").collection("Speaker").doc('Reminder').get().then(function (mailtpl) {
                                if (mailtpl.exists) {
                                    var bodyHtml = mailtpl.data().html;
                                    bodyHtml = bodyHtml.replace("{{StartDate}}", field.data.StartDateTZ);
                                    bodyHtml = bodyHtml.replace("{{StartTime}}", field.data.StartTimeTZ);
                                    bodyHtml = bodyHtml.replace("{{EndDate}}", field.data.EndDateTZ);
                                    bodyHtml = bodyHtml.replace("{{EndTime}}", field.data.EndTimeTZ);
                                    bodyHtml = bodyHtml.replace("{{TimeZone}}", field.data.TimeZone);
                                    bodyHtml = bodyHtml.replace("{{CustomDomain}}", customDomain);
                                    bodyHtml = bodyHtml.replace("{{CustomDomain}}", customDomain);
                                    con.eventDB.collection(docObj.EventCollectionName).doc("mailtpl").collection("Speaker").doc('Reminder').set({ designJson: mailtpl.data().designJson,html: bodyHtml, htmlRaw: mailtpl.data().html, subject: mailtpl.data().subject })
                                } else {
                                    con.eventDB.collection(docObj.EventCollectionName).doc("mailtpl").collection("Speaker").doc('Reminder').set({ designJson: '',html: '', htmlRaw: '', subject: '' })
                                }
                            })

                            con.instanceDB.doc("mailtpl").collection("EventAdmin").doc('WelcomeMail').get().then(function (mailtpl) {
                                if (mailtpl.exists) {
                                    con.eventDB.collection(docObj.EventCollectionName).doc("mailtpl").collection("EventAdmin").doc('WelcomeMail').set({ html: mailtpl.data().html, subject: mailtpl.data().subject })
                                } else {
                                    con.eventDB.collection(docObj.EventCollectionName).doc("mailtpl").collection("EventAdmin").doc('WelcomeMail').set({ html: '', subject: '' })
                                }
                            })

                            con.instanceDB.doc("mailtpl").collection("Exhibitor").doc('BusinessCardAttendee').get().then(function (mailtpl) {
                                if (mailtpl.exists) {
                                    con.eventDB.collection(docObj.EventCollectionName).doc("mailtpl").collection("Exhibitor").doc('BusinessCardAttendee').set({ Html: mailtpl.data().Html, html: mailtpl.data().Html, subject: mailtpl.data().subject })
                                } else {
                                    con.eventDB.collection(docObj.EventCollectionName).doc("mailtpl").collection("Exhibitor").doc('BusinessCardAttendee').set({ Html: '', html: '', subject: '' })
                                }
                            })

                            con.instanceDB.doc("mailtpl").collection("Exhibitor").doc('BusinessCardExhibitor').get().then(function (mailtpl) {
                                if (mailtpl.exists) {
                                    con.eventDB.collection(docObj.EventCollectionName).doc("mailtpl").collection("Exhibitor").doc('BusinessCardExhibitor').set({ Html: mailtpl.data().Html, html: mailtpl.data().Html, subject: mailtpl.data().subject })
                                } else {
                                    con.eventDB.collection(docObj.EventCollectionName).doc("mailtpl").collection("Exhibitor").doc('BusinessCardExhibitor').set({ Html: '', html: '', subject: '' })
                                }
                            })
                            con.instanceDB.doc("mailtpl").collection("AnalyticsAdmin").doc('WelcomeMail').get().then(function (mailtpl) {
                                if (mailtpl.exists) {
                                    con.eventDB.collection(docObj.EventCollectionName).doc("mailtpl").collection("AnalyticsAdmin").doc('WelcomeMail').set({ html: mailtpl.data().html, subject: mailtpl.data().subject })
                                } else {
                                    con.eventDB.collection(docObj.EventCollectionName).doc("mailtpl").collection("AnalyticsAdmin").doc('WelcomeMail').set({ html: '', subject: '' })
                                }
                            })

                            con.instanceDB.doc("Features").get().then(function (fdoc) {
                                if (fdoc.exists) {
                                    let Features = [];                                    
                                    fdoc.data().Features.forEach(feature => {
                                        if (feature.IsDefault) {
                                            Features.push(feature)
                                        }
                                    });
                                    con.eventDB.collection(docObj.EventCollectionName).doc('Features').set({ CreatedTime: new Date(), Features: Features, ModifiedTime: new Date() });
                                } else {
                                    con.eventDB.collection(docObj.EventCollectionName).doc('Features').set({ CreatedTime: new Date(), Features: [], ModifiedTime: new Date() });
                                }
                            })

                            con.instanceDB.doc("Menu").get().then(function (mdoc) {
                                if (mdoc.exists) {
                                    let AllMenu = mdoc.data().AllMenu;
                                    let TopMenu = [];
                                    let LeftMenu = [];
                                    AllMenu.forEach(menu => {
                                        if ([8,7].includes(menu.FeatureID)) {
                                            TopMenu.push(menu)
                                        }
                                        if ([1,2].includes(menu.FeatureID)) {
                                            LeftMenu.push(menu)
                                        }
                                    });
                                    con.eventDB.collection(docObj.EventCollectionName).doc('Menu').set({ CreatedTime: new Date(), AllMenu: TopMenu, LeftMenu: LeftMenu, ModifiedTime: new Date() });
                                }
                                else
                                {
                                    con.eventDB.collection(docObj.EventCollectionName).doc('Menu').set({ CreatedTime: new Date(), AllMenu: [], LeftMenu: [], ModifiedTime: new Date() });
                                }
                            })

                            con.eventDB.collection(docObj.EventCollectionName).doc('ExhibitorList').set({});
                            con.eventDB.collection(docObj.EventCollectionName).doc('LocationList').set({});
                            con.eventDB.collection(docObj.EventCollectionName).doc('MeetingList').set({});
                            con.eventDB.collection(docObj.EventCollectionName).doc('PhotoWall').set({});
                            con.eventDB.collection(docObj.EventCollectionName).doc('RoundTableList').set({});
                            con.eventDB.collection(docObj.EventCollectionName).doc('RoundTableTopicList').set({});
                            con.eventDB.collection(docObj.EventCollectionName).doc('SessionList').set({});
                            con.eventDB.collection(docObj.EventCollectionName).doc('SpeakerList').set({});
                            con.eventDB.collection(docObj.EventCollectionName).doc('SponsorList').set({});
                            con.eventDB.collection(docObj.EventCollectionName).doc('TrackList').set({});
                            con.eventDB.collection(docObj.EventCollectionName).doc('Settings').set({});
                            let RTTObj = {
                                CreatedBy: ls.getSessionValueByKey('UserId'),
                                CreatedDate: new Date(),
                                TopicId: "RTT" + new Date().getTime(),
                                TopicName: 'General',
                                IsPrivate: true,
                                LastModifiedDate: new Date(),
                                TableCapacity: '12'
                            };
                            con.eventDB.collection(docObj.EventCollectionName).doc('RoundTableTopicList').collection('RoundTableTopics').doc(`${RTTObj.TopicId}`).set(RTTObj);                            

                            context.dispatch('createBrandingJson', { EventCollectionName: docObj.EventCollectionName, EventInfo: docObj });                            
                            
                            con.instanceDB.doc('ClientList').collection('Clients').doc(Session_Client_Id).collection('Events').doc(AutoID).set(docObj).then(function () {
                                resolve({ status: 200, message: 'Event Created.', Id: AutoID, data: docObj });
                                //context.dispatch('uploadBrandingJsonHexCodeType', { brandingJson: field.brandingJson }).then(function() {});
                            });
                        }); // end of EventInfo
                    });
                });
            });
        });
    },
    addEventAPI(context, field) {
        return new Promise((resolve, reject) => {
            let docObj = {
                AllowRegistration: field.data.AllowRegistration == undefined ? false : field.data.AllowRegistration,
                ExternalRegistrationEnabled: field.data.AllowRegistration && field.data.ExternalRegistrationEnabled ? true : false,
                ExternalRegistrationLink: field.data.ExternalRegistrationLink ? field.data.ExternalRegistrationLink : null,
                TimeZone: field.data.TimeZone,
                AttendeeCount: 0,
                BackgroundColor: '',
                ClientCollectionName: ClientCollectionName,
                ClientId: Session_Client_Id,
                CreatedTime: new Date(),
                DateFormat: 'dd MMM yyyy',
                E2MEventId: 0,
                EventCode: 0,
                StartDate: (field.data.StartDate ? field.data.StartDate : null),
                EndDate: (field.data.EndDate ? field.data.EndDate : null),
                StartDateTZ: field.data.StartDateTZ,
                StartTimeTZ: field.data.StartTimeTZ,
                EndDateTZ: field.data.EndDateTZ,
                EndTimeTZ: field.data.EndTimeTZ,
                EventFullName: field.data.EventFullName.trim(),
                EventSlug: field.data.EventSlug.trim(),
                EventShortName: field.data.EventFullName.trim(),
                IsPublished: false,
                EventTypeId: parseInt(field.data.EventType),
                ExhibitorCount: 0,
                LobbyType: 1,
                ModifiedTime: new Date(),
                RoundTableCount: 0,
                SessionCount: 0,
                SpeakerCount: 0,
                SponsorCount: 0,
                UseBackgroundImage: false,
                EventType: field.data.EventType,
                Description: field.data.Description,
                LocationType: (field.data.LocationType ? field.data.LocationType : { Id: 2, Name: "Virtual" }),
                Venue: field.data.Venue,
                DefaultLandingURL: field.data.DefaultLandingURL ? field.data.DefaultLandingURL : '/lobby',
                EventAccessType: (field.data.EventAccessType ? field.data.EventAccessType : 'Unique Passcode per Attendee'),
                defaultEP: (field.data.EventAccessType == 'Use Common Event Passcode' && field.data.defaultEP ? field.data.defaultEP : null),
                postToCRM: field.data.postToCRM ? true : false,
                HideEventHeaderAndMenu: field.data.HideEventHeaderAndMenu ? true : false,
                EnableEmailOnlyLogin: field.data.EnableEmailOnlyLogin ? true : false,
                AllowPublicAccess: field.data.AllowPublicAccess ? true : false,
                RegistrationVersion: field.data.RegistrationVersion ? field.data.RegistrationVersion : 1,
                ShowProfileEditOnWelcome: field.data.ShowProfileEditOnWelcome ? true : false,
                AllowProfileEdit: field.data.AllowProfileEdit ? true : false,
                showAttendeePresenceBubble: field.data.showAttendeePresenceBubble ? true : false,
                WelcomeMessage: field.data.WelcomeMessage ? field.data.WelcomeMessage : null,
                DisableLanguageOption: field.data.DisableLanguageOption ? true : false,
                LogoutRedirectURL: field.data.LogoutRedirectURL ? field.data.LogoutRedirectURL : null,
                StreamingClient: field.data.StreamingClient ? field.data.StreamingClient : 'Zoom',
                approval_type: field.data.approval_type != undefined ? field.data.approval_type : 0,
                DefaultLanguage: field.data.DefaultLanguage != null ? field.data.DefaultLanguage : 'English',
                Features: field.SelectedFeatures,
            };
            let accessToken = ls.getSessionValueByKey("Session_AccessToken");
            let headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${accessToken}`,
            }
            let requestData = {
                "key": {
                    "instanceId": "OA_UAT",
                    "clientId": Session_Client_Id,
                    "userId": Session_UserId
                },
                "data": docObj,
            };
            axios.post(CreateEventAPI, requestData, { headers: headers }).then(function (res) {
                if(res.data.status == 200){
                    resolve({ status: 200, message: 'Event Created.', Id: res.data.Id, data: res.data.data });
                }
                else
                    resolve({ status: 500, message: 'Event Not Created.' });
            }).catch(err=>{ reject(err) })

        });
    },
    setVirtuallobby(context, eventObj){
        return new Promise((resolve, reject) => {
            let lobbyData = {
                "PhotoScrollerLeft": "",
                "PhotoScrollerRight": "",
                "PhotoScrollLeftHeading": "Thank You",
                "CountDownTime": "60",
                "HidePhotoScrollLeft": "ShowPhotoScrollLeftHide",
                "headlineText": eventObj.EventFullName.trim(),
                "JoinButtonUrl": "/sessions",
                "JoinButtonText": "",
                "coundownLobby": {
                    "joinButtonFontColor": "#ffffff",
                    "photoWallBGColor": "rgba(255, 255, 255, 0.29)",
                    "navcolor": "#ffffff",
                    "joinButtonShadowColor": "#0d551b",
                    "bgImageIpad": "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1591205467009E1591206650065%2FImage%2Fsection-bg.jpg?alt=media",
                    "HeaderTextColor": "#ffffff",
                    "sponsorBGColor": "#000000",
                    "joinButtonBGColor": "#19852e",
                    "photoWallBorderColor": "rgba(255, 255, 255, 0.29)",
                    "bgImagePath": "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1591205467009E1591206650065%2FImage%2Fsection-bg.jpg?alt=media",
                    "bgImageApp": "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1591205467009E1591206650065%2FImage%2Fsplash-xxhdpi.png?alt=media",
                    "sponsorBorderColor": "#500a48"
                },
                "IsVideoControl": "V_ConDisable",
                "PhotoScrollRightHeading": "PHOTO WALL",
                "VideoURL": "",
                "MusicURL": "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/Sounds%2Flobby_1234567890.mp3?alt=media",
                "VideoLength": 5,
                "LeftPanelPhotoWallAlbum": [],
                "PhotoScrollRightSubHeading": "",
                "IsBackgroundMusic": "PlayAlways",
                "AutoRedirectMicrositeWhenCountdownCompleted": "Disable",
                "PhotoScrollLeftSubHeading": "SPONSOR",
                "RightPanelPhotoWallAlbum": [],
                "LastModifiedDate": new Date(),
                "HideBottomMenu": "false",
                "hostedBy": null,
                "HidePhotoScrollRight": "ShowPhotoScrollRightHide",
                "RedirectURL": "",
                "LeftPanelImageTransitionDelay": "2",
                "RightPanelImageTransitionDelay": "2",
                "AdditionalButtons": {
                    "LeftSubButtonLabel": "Attendees",
                    "MiddleSubButtonLabel": "Speakers",
                    "LeftSubButtonURL": "/attendee",
                    "RightSubButtonURL": "/roundtable",
                    "MiddleSubButtonURL": "/speakers",
                    "RightSubButtonLabel": "Roundtables"
                },
                "EnableSubButtons": false,
                "HideEventName": false,
                "HamburgerBarColor": "#000000",
                "HamburgerIcon": null
            }
            con.eventDB.collection(eventObj.EventCollectionName).doc('VirtualLobby').set(lobbyData);
        })
    },
    fetchEventAdmins({ commit }, EventId) {
        return new Promise((resolve, reject) => {
            let admins = [];
            let headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
            }
            let requestData = {
                "key": {
                    "eventId": "",
                    "clientId": Session_Client_Id,
                    "instanceId": "OA_UAT"
                },
                "data": {
                    "UserId": null
                }
            }
            userEventsRef.where("AdminEventIDs", "array-contains", EventId).get().then(function (querySnapshot) {
                if (!querySnapshot.empty) {
                    querySnapshot.docs.forEach(eventsdoc => {
                        requestData.data.UserId = eventsdoc.data().UserId;
                        axios.post(CheckUserValidAPI, requestData, { headers: headers }).then(response => {
                            let usersdoc = response.data.result
                            let found = usersdoc.UserRoles.some(el => el.RoleID === 3);
                            if (found) {
                                var data = usersdoc;
                                data.EventId = EventId;
                                admins.push(data);
                            }
                        });
                    });
                }
                resolve(admins);
            })
            userEventsRef.where("AnalyticsAdminEventIDs", "array-contains", EventId).get().then(function (querySnapshot) {
                if (!querySnapshot.empty) {
                    querySnapshot.docs.forEach(eventsdoc => {
                        requestData.data.UserId = eventsdoc.data().UserId;
                        axios.post(CheckUserValidAPI, requestData, { headers: headers }).then(response => {
                            let usersdoc = response.data.result
                            let found = usersdoc.UserRoles.some(el => el.RoleID === 4);
                            if (found) {
                                var data = usersdoc;
                                data.EventId = EventId;
                                admins.push(data);
                            }
                        });
                    });
                }
                resolve(admins);
            }).catch(function (error) {
                //console.log('Error getting attendee:', error);
                reject(error);
            });
        });
    },
    fetchEventAdmin(context, field) {
        return new Promise((resolve, reject) => {
            let headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
            }
            let requestData = {
                "key": {
                    "eventId": "",
                    "clientId": Session_Client_Id,
                    "instanceId": "OA_UAT"
                },
                "data": {
                    "UserId": `${field.EventAdminId}`
                }
            }
            axios.post(CheckUserValidAPI, requestData, { headers: headers }).then(response => {
                resolve(response.data.result)
            }).catch(function (error) {
                reject(error)
            })

        })
    },
    updateEventAdmin(context, field) {
        return new Promise((resolve, reject) => {
            let headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
            }
            let requestData = {
                "key": {
                    "eventId": field.data.EventId,
                    "clientId": Session_Client_Id,
                    "instanceId": "OA_UAT"
                },
                "data": {
                    UserId: `${field.data.EventAdminId}`,
                    FirstName: field.data.FirstName.trim(),
                    LastName: field.data.LastName.trim(),
                    Company: field.data.Company
                }
            }
            axios.post(UpdateUserAPI, requestData, { headers: headers }).then(response => {
                if(response.data.status == 0)
                    resolve({ status: 200, message: 'Admin Updated.' })
                else
                    resolve({ status: 500, message: 'Admin Not Updated.' })
            }).catch(function (error) {
                reject(error)
            })

        })
    },
    addEventAdminBK(context, field) {
        return new Promise((resolve, reject) => {
            if (field.data.Email == '') {
                resolve({ status: 500, message: 'Enter proper email!.' })
            } else {

                let docObj = {
                    EventId: field.data.EventId,
                    EventCollectionName: field.data.EventCollectionName,
                    EventFullName: field.data.EventFullName,
                    EventAdminId: null,
                    FirstName: field.data.FirstName,
                    LastName: field.data.LastName,
                    Company: field.data.Company,
                    Email: field.data.Email,
                    Password: null,
                    AdminType: field.data.adminType,
                }

                let attendeObj = {
                    AttendeeId: null,
                    EventId: field.data.EventId,
                    Name: field.data.FirstName + ' ' + field.data.LastName,
                    FirstName: field.data.FirstName,
                    LastName: field.data.LastName,
                    Email: field.data.Email,
                    Password: null,
                    Phone: '',
                    Country: '',
                    Company: field.data.Company,
                    Designation: null,
                    Profile: '',
                    ProfilePictureURL: '',
                    Website: '',
                    SocialLinks: [
                        { Facebook: '' },
                        { GooglePlus: '' },
                        { LinkedIn: '' },
                        { Twitter: '' }
                    ],
                    Tags: '',
                    MailSent: false,
                    IsVerified: false,
                    IsPublished: true,
                    UserRoles: [{ RoleID: 10, RoleName: "AppUser" }],
                    //CreatedDate: new Date(),
                    //LastModifiedDate: new Date(),
                    AdminType: field.data.adminType
                }

                if (attendeObj.AdminType == "EventAdmin") {
                    attendeObj.IsEventAdmin = true
                    attendeObj.IsAnalyticsAdmin = false
                    attendeObj.UserRoles = [{ RoleID: 10, RoleName: "AppUser" },{ RoleID: 3, RoleName: 'EventAdmin' }];
                } else {
                    attendeObj.IsEventAdmin = false
                    attendeObj.IsAnalyticsAdmin = true
                    attendeObj.UserRoles = [{ RoleID: 10, RoleName: "AppUser" },{ RoleID: 4, RoleName: 'AnalyticsAdmin' }];
                }

                let headers = {
                    "Content-Type": "application/json",
                    'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`,
                    "x-api-key": DeleteAttendeeApiKey
                }
                let requestData = {
                    "key": {
                        "eventId": field.data.EventId,
                        "clientId": Session_Client_Id,
                        "instanceId": "OA_UAT"
                    },
                    "data": attendeObj,
                    "sendMail": 0
                }
                
                context.dispatch('checkUser', attendeObj).then(userData=>{                    
                    axios.post(AddSingleAttendeeAPI, requestData, { headers: headers }).then(function (userRes) {
                        if (!userData.DifferentClient) {
                            if(userData.PreviousRole)
                            {
                                let PreviousRole = '';
                                if(userData.PreviousRole == 2)
                                    PreviousRole = 'Client Admin'
                                else if(userData.PreviousRole == 3)
                                    PreviousRole = 'Event Admin'
                                else if(userData.PreviousRole == 4)
                                    PreviousRole = 'Analytics Admin'
                                resolve({ status: 500, message: `User already has a role of - ${PreviousRole}` })
                            }
                            else
                            {
                                if(userData.UserId)
                                {
                                    let Userdata = {
                                        UserId: userData.UserId,
                                        UserRoles: attendeObj.UserRoles
                                    }
                                    context.dispatch('updateUserbyId', {Userdata: Userdata, EventId:field.data.EventId});
                                }
                                let userId = userData.UserId ? userData.UserId : userRes.data.data.AttendeeId
                                docObj.EventAdminId = userId                                
                                userEventsRef.doc(`${userId}`).get().then(function (userEvent) {
                                    if (!userEvent.exists) {
                                        if (docObj.AdminType == "EventAdmin") {
                                            userEventsRef.doc(`${userId}`).set({
                                                UserId: userId,
                                                EventIDs: [docObj.EventId],
                                                AdminEventIDs: [docObj.EventId],
                                                LastModifiedDate: new Date()
                                            })
                                        } else {
                                            userEventsRef.doc(`${userId}`).set({
                                                UserId: userId,
                                                EventIDs: [docObj.EventId],
                                                AnalyticsAdminEventIDs: [docObj.EventId],
                                                LastModifiedDate: new Date()
                                            })
                                        }
                                    } else {
                                        if (docObj.AdminType == "EventAdmin") {
                                            userEventsRef.doc(`${userId}`).update({
                                                EventIDs: firebase.firestore.FieldValue.arrayUnion(docObj.EventId),
                                                AdminEventIDs: firebase.firestore.FieldValue.arrayUnion(docObj.EventId),
                                                LastModifiedDate: new Date()
                                            })
                                        } else {
                                            userEventsRef.doc(`${userId}`).update({
                                                EventIDs: firebase.firestore.FieldValue.arrayUnion(docObj.EventId),
                                                AnalyticsAdminEventIDs: firebase.firestore.FieldValue.arrayUnion(docObj.EventId),
                                                LastModifiedDate: new Date()
                                            })
                                        }
                                    }
                                    context.dispatch('sendMail', docObj);
                                    resolve({ status: 200, message: 'Admin Created & Mail Sent.' })
                                })
                            }

                        } else {
                            resolve({ status: 500, message: 'User should be of same client!' })
                        }
                    }).catch(err=> reject(err))
                })
            }
        })
    },
    addEventAdmin(context, field) {
        return new Promise((resolve, reject) => {
            if (field.data.Email == '') {
                resolve({ status: 500, message: 'Enter proper email!.' })
            } else {

                let docObj = {
                    EventId: field.data.EventId,
                    EventCollectionName: field.data.EventCollectionName,
                    EventFullName: field.data.EventFullName.trim(),
                    EventAdminId: null,
                    FirstName: field.data.FirstName.trim(),
                    LastName: field.data.LastName.trim(),
                    Company: field.data.Company,
                    Email: field.data.Email.trim(),
                    Password: null,
                    AdminType: field.data.adminType,
                }

                let attendeObj = {
                    AttendeeId: null,
                    EventId: field.data.EventId,
                    Name: field.data.FirstName + ' ' + field.data.LastName,
                    FirstName: field.data.FirstName,
                    LastName: field.data.LastName,
                    Email: field.data.Email,
                    Password: null,
                    Phone: '',
                    Country: '',
                    Company: field.data.Company,
                    Designation: null,
                    Profile: '',
                    ProfilePictureURL: '',
                    Website: '',
                    SocialLinks: [
                        { Facebook: '' },
                        { GooglePlus: '' },
                        { LinkedIn: '' },
                        { Twitter: '' }
                    ],
                    Tags: '',
                    MailSent: false,
                    IsVerified: false,
                    IsPublished: true,
                    UserRoles: [{ RoleID: 10, RoleName: "AppUser" }],
                    //CreatedDate: new Date(),
                    //LastModifiedDate: new Date(),
                    AdminType: field.data.adminType
                }

                if (attendeObj.AdminType == "EventAdmin") {
                    attendeObj.IsEventAdmin = true
                    //attendeObj.IsAnalyticsAdmin = false
                    //attendeObj.UserRoles = [{ RoleID: 10, RoleName: "AppUser" },{ RoleID: 3, RoleName: 'EventAdmin' }];
                } else {
                    //attendeObj.IsEventAdmin = false
                    attendeObj.IsAnalyticsAdmin = true
                    //attendeObj.UserRoles = [{ RoleID: 10, RoleName: "AppUser" },{ RoleID: 4, RoleName: 'AnalyticsAdmin' }];
                }

                let headers = {
                    "Content-Type": "application/json",
                    'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`,
                    "x-api-key": DeleteAttendeeApiKey
                }
                let requestData = {
                    "key": {
                        "eventId": field.data.EventId,
                        "clientId": Session_Client_Id,
                        "instanceId": "OA_UAT"
                    },
                    "data": attendeObj,
                    "sendMail": 0
                }
                axios.post(CheckUserValidAPI, requestData, { headers: headers }).then(res => {
                    let prevRoles = res && res.data && res.data.result && res.data.result.AdminRoles ? res.data.result.AdminRoles : [];
                    let prevRoleFound =  prevRoles.some(el => el.ClientId == Session_Client_Id && el.EventId == field.data.EventId && el.RoleName == attendeObj.AdminType)
                    if(!prevRoleFound){
                        axios.post(AddSingleAttendeeAPI, requestData, { headers: headers }).then(function (userRes) {
                            if(userRes.status == 200){
                                context.dispatch('sendMail', docObj);
                                resolve({ status: 200, message: 'Admin Created & Mail Sent.' })
                            }
                            else
                                resolve({ status: 500, message: 'Admin not Created!' })
                        }).catch(err=>{ reject(err) })
                    }
                    else
                        resolve({ status: 500, message: `Already has the role of ${attendeObj.AdminType}` })
                })
            }
        })
    },
    deleteEventAdmin(context, field) {
        return new Promise((resolve, reject) => {
            let headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
            }
            let requestData = {
                "key": {
                    "eventId": field.EventId,
                    "clientId": Session_Client_Id,
                    "instanceId": "OA_UAT"
                },
                "data": {
                    UserId: `${field.UserId}`,
                    UserRoles: []
                }
            }
            if (field.RoleName == "EventAdmin") {
                userEventsRef.doc(`${field.UserId}`).update({
                    AdminEventIDs: firebase.firestore.FieldValue.arrayRemove(field.EventId),
                    LastModifiedDate: new Date()
                }).then(function () {

                    userEventsRef.doc(`${field.UserId}`).get().then(function (userEvent) {
                        if (userEvent.data().AdminEventIDs.length) {
                            resolve("Removed Successfully");
                        } else {                            
                            context.dispatch('getUserDetailbyId', `${field.UserId}`).then(userDetail => {
                                if(userDetail){
                                    let UserRoles = userDetail.UserRoles.filter((item) => item.RoleID !== 3);
                                    let AdminRoles = userDetail.AdminRoles.filter((item) => (item.ClientId == Session_Client_Id && item.EventId == field.EventId) && item.RoleID !== 3);
                                    requestData.data.UserRoles = UserRoles;
                                    requestData.data.AdminRoles = AdminRoles;
                                    axios.post(UpdateUserAPI, requestData, { headers: headers }).then(response => {
                                        if(response.data.status == 0)
                                            resolve("Removed Successfully");
                                        else
                                            resolve("Not Removed!");
                                    })
                                }                                
                            })
                        }
                    })
                })

            } else if (field.RoleName == "AnalyticsAdmin") {
                userEventsRef.doc(`${field.UserId}`).update({
                    AnalyticsAdminEventIDs: firebase.firestore.FieldValue.arrayRemove(field.EventId),
                    LastModifiedDate: new Date()
                }).then(function () {

                    userEventsRef.doc(`${field.UserId}`).get().then(function (userEvent) {
                        if (userEvent.data().AnalyticsAdminEventIDs.length) {
                            resolve("Removed Successfully");
                        } else {
                            context.dispatch('getUserDetailbyId', `${field.UserId}`).then(userDetail => {
                                if(userDetail){
                                    let UserRoles = userDetail.UserRoles.filter((item) => item.RoleID !== 4);
                                    let AdminRoles = userDetail.AdminRoles.filter((item) => (item.ClientId == Session_Client_Id && item.EventId == field.EventId) && item.RoleID !== 4);
                                    requestData.data.UserRoles = UserRoles;
                                    requestData.data.AdminRoles = AdminRoles;
                                    axios.post(UpdateUserAPI, requestData, { headers: headers }).then(response => {
                                        if(response.data.status == 0)
                                            resolve("Removed Successfully");
                                        else
                                            resolve("Not Removed!");
                                    })
                                }                                
                            })
                        }
                    })
                })
            }
            else {
                resolve("Not Removed!");
            }
        });
    },
    sendMail(context, field) {
        var html = '';
        var cn = field.EventCollectionName;
        let subject = "You are Invited to manage:"
        let promise = new Promise((resolve, reject) => {
            clientRef.doc(Session_Client_Id).get().then(function (clientDetail) {
                con.eventDB.collection(cn).doc("EventInfo").get().then(function (eventDetail) {
                    if (field.AdminType == "EventAdmin") {
                        con.eventDB.collection(cn).doc("mailtpl").collection("EventAdmin").doc("WelcomeMail").get().then(function (mailtpl) {
                            let source = mailtpl.data().html;
                            let template = Handlebars.compile(source);
                            context.dispatch('getUserDetailbyId', `${field.EventAdminId}`).then(userDetail => {
                                let formatedText = {
                                    CustomDomain: clientDetail.data().CustomDomain,
                                    EventName: eventDetail.data().EventFullName,
                                    CMSDomain: window.location.hostname,
                                    Email: userDetail.Email,
                                    Password: userDetail.Password,
                                    FirstName: userDetail.FirstName,
                                    EventBanner: eventDetail.data().EventBanner,
                                    ClientEmail: clientDetail.data().ClientEmail
                                };
                                html = template(formatedText);
                                subject = mailtpl.data().subject.replace("{{EventName}}", eventDetail.data().EventFullName)
                                var requestData = {
                                    "from": {
                                        "email": mailtpl.data().from ? mailtpl.data().from : "noreply@mail.e2m.live",
                                        "name": "E2M OnAir: " + eventDetail.data().EventFullName
                                    },
                                    "to": {
                                        "name": userDetail.Name,
                                        "email": userDetail.Email.toLowerCase()
                                    },
                                    //"subject": "You're in - " + ls.getSessionValueByKey('Session_Event_FullName'),
                                    "subject": subject,
                                    "html": html
                                };
                                const headers = {
                                    "Content-Type": "application/json",
                                    'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
                                }
                                axios.post(SINGLEEMAILAPIURL, requestData, { headers: headers })
                                    .then((response) => {
                                        if (response.status == 200) {
                                            resolve({ status: 200, message: "Mail sent to User" })
                                        }

                                    })
                                    .catch((error) => { console.log(error) })

                                //})        
                            }) // end of where in firebase
                        })
                    } else {
                        con.eventDB.collection(cn).doc("mailtpl").collection("AnalyticsAdmin").doc("WelcomeMail").get().then(function (mailtpl) {
                            let source = mailtpl.data().html;
                            let template = Handlebars.compile(source);
                            context.dispatch('getUserDetailbyId', `${field.EventAdminId}`).then(userDetail => {

                                let formatedText = {
                                    CustomDomain: clientDetail.data().CustomDomain,
                                    EventName: eventDetail.data().EventFullName,
                                    CMSDomain: window.location.hostname,
                                    Email: userDetail.Email,
                                    Password: userDetail.Password,
                                    FirstName: userDetail.FirstName,
                                    EventBanner: eventDetail.data().EventBanner,
                                    ClientEmail: clientDetail.data().ClientEmail
                                };
                                html = template(formatedText);
                                subject = mailtpl.data().subject.replace("{{EventName}}", eventDetail.data().EventFullName)
                                var requestData = {
                                    "from": {
                                        "email": mailtpl.data().from ? mailtpl.data().from : "noreply@mail.e2m.live",
                                        "name": "E2M OnAir: " + eventDetail.data().EventFullName
                                    },
                                    "to": {
                                        "name": userDetail.Name,
                                        "email": userDetail.Email.toLowerCase()
                                    },
                                    //"subject": "You're in - " + ls.getSessionValueByKey('Session_Event_FullName'),
                                    "subject": subject,
                                    "html": html
                                };
                                const headers = {
                                    "Content-Type": "application/json",
                                    'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
                                }
                                axios.post(SINGLEEMAILAPIURL, requestData, { headers: headers })
                                    .then((response) => {
                                        if (response.status == 200) {
                                            resolve({ status: 200, message: "Mail sent to User" })
                                        }

                                    })
                                    .catch((error) => { console.log(error) })

                                //})        
                            }) // end of where in firebase
                        })
                    }
                }) // end of event
            })
        }) // end of promise
        return promise;
    },
    checkUser(context, userObj) {
        return new Promise((resolve, reject) => {  
            let headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
            }
            let requestData = {
                "key": {
                    "eventId": "",
                    "clientId": Session_Client_Id,
                    "instanceId": "OA_UAT"
                },
                "data": null
            }          
            requestData.data = { Email: userObj.Email.toLowerCase() }       
            axios.post(CheckUserValidAPI, requestData, { headers: headers }).then(snapShot => {
                let doc = snapShot.data.result;
                let Session_Event_Id = userObj.EventId;
                delete userObj.EventId;                
                if (!snapShot.data.userStatus) {
                    resolve({UserId: 0, PreviousRole: 0, DifferentClient: false})
                } else {                    
                    let PreviousRole = 0;
                    let AllocatedRole = userObj.AdminType == "EventAdmin" ? 3 : 4;
                    doc.UserRoles.map(row=>{
                        if(row.RoleID == 2)
                            PreviousRole = row.RoleID
                        else if([3,4].includes(row.RoleID) && row.RoleID != AllocatedRole)   
                            PreviousRole = row.RoleID                 
                    })

                    if (doc.ClientId == undefined || doc.ClientId == Session_Client_Id) {
                        resolve({UserId: doc.UserId, PreviousRole: PreviousRole, DifferentClient: false});
                    } else {
                        resolve({UserId: doc.UserId, PreviousRole: 0, DifferentClient: true});
                    }

                }
            }).catch(err => { reject(err) })
        })
    },
    async getAutoId(context) {
        //let AutoId = 0;
        let promise = new Promise((resolve, reject) => {
            con.instanceDB.doc("AutoID").get().then(function (doc) {
                if (!doc.exists) {
                    con.instanceDB.doc("AutoID").set({ UserId: 0 })
                    resolve(1)
                } else {
                    con.instanceDB.doc("AutoID").update({
                        UserId: firebase.firestore.FieldValue.increment(1)
                    }).then(function () {
                        con.instanceDB.doc("AutoID").get().then(function (doc) {
                            resolve(doc.data().UserId)
                        })
                    })
                }
            })
        })

        let AutoId = await promise;
        AutoId = AutoId * 1000;
        return await AutoId.toString();
    },
    generateNumber(context, numberLength) {
        const random = new Random(); // uses the nativeMath engine
        //const value = random.hex(numberLength);
        const value = random.integer(100000, 999999);
        return value.toString();
    },
    uploadImage(context, field) {
        return new Promise((resolve, reject) => {
            if (field.file && field.path) {
                let path = field.path;
                let file = field.file
                let metadata = {
                    'contentType': file.type
                }
                storageRef.child(path + (new Date().getTime()) + "_" + file.name).put(file, metadata).then(function (snapshot) {
                    snapshot.ref.getDownloadURL().then(function (url) {
                        resolve(url.toString())
                    })
                })
            } else {
                resolve('')
            }
        })
    },
    createBrandingJson(context, field) {
        let path = ClientCollectionName + '/Defaults/Branding.json';
        return new Promise((resolve, reject) => {
            storageRef.child(path).getDownloadURL().then(function (url) {
                axios.get(url.toString()).then(result => {
                    let jsonObj = null
                    if (typeof result.data == 'string')
                        jsonObj = eval('(' + result.data + ')');
                    else if (typeof result.data == 'object')
                        jsonObj = result.data
                    else
                        jsonObj = null
                    if (jsonObj) {
                        jsonObj.uploadCustomLogoAndBanner = jsonObj.uploadCustomLogoAndBanner == undefined ? true : jsonObj.uploadCustomLogoAndBanner;
                        jsonObj.postToCRM = field.EventInfo.postToCRM ? true : false;
                        jsonObj.HideEventHeaderAndMenu = field.EventInfo.HideEventHeaderAndMenu ? true : false;
                        jsonObj.EnableEmailOnlyLogin = field.EventInfo.EnableEmailOnlyLogin ? true : false;
                        jsonObj.AllowPublicAccess = field.EventInfo.AllowPublicAccess ? true : false;  
                        jsonObj.ShowProfileEditOnWelcome = field.EventInfo.ShowProfileEditOnWelcome ? true : false;
                        jsonObj.AllowProfileEdit = field.EventInfo.AllowProfileEdit ? true : false;
                        jsonObj.showAttendeePresenceBubble = field.EventInfo.showAttendeePresenceBubble ? true : false;
                        jsonObj.WelcomeMessage = field.EventInfo.WelcomeMessage ? field.data.WelcomeMessage : null; 
                        jsonObj.DisableLanguageOption = field.EventInfo.DisableLanguageOption ? true : false;
                        jsonObj.LogoutRedirectURL = field.EventInfo.LogoutRedirectURL ? field.data.LogoutRedirectURL : null;                      
                        jsonObj.StreamingClient = field.EventInfo.StreamingClient ? field.EventInfo.StreamingClient : 'Zoom';
                        jsonObj.approval_type = field.EventInfo.approval_type != undefined ? field.EventInfo.approval_type : 0;
                        clientRef.doc(`${field.EventInfo.ClientId}`).get().then(function (doc) {
                            if (doc.exists) {
                                let data = doc.data()

                                jsonObj.ClientInfo = {};
                                jsonObj.ClientInfo.ClientId = data.ClientId;
                                jsonObj.ClientInfo.ClientName = data.ClientName;
                                jsonObj.ClientInfo.LoginAssets = data.LoginAssets == undefined ? {} : data.LoginAssets;
                                jsonObj.ClientInfo.LastModifiedTime = data.LastModifiedTime;
                                jsonObj.ClientInfo.EventListAssets = data.EventListAssets == undefined ? {} : data.EventListAssets;
                                jsonObj.ClientInfo.Favicon = data.Favicon;
                                jsonObj.ClientInfo.AllowRegister = data.AllowRegister;
                                jsonObj.ClientInfo.SSOEnabled = data.SSOEnabled;
                                jsonObj.ClientInfo.SocialAuths = data.SocialAuths == undefined ? {} : data.SocialAuths;
                                jsonObj.ClientInfo.CustomDomain = data.CustomDomain;
                                jsonObj.ClientInfo.SSODomain = data.SSODomain;
                                jsonObj.ClientInfo.Company = data.Company;

                                if (jsonObj.HostInfo == undefined) {
                                    jsonObj.HostInfo = {};
                                }
                                if (jsonObj.HostInfo.Name == undefined || jsonObj.HostInfo.Name == "") {
                                    jsonObj.HostInfo.Name = data.ClientName;
                                }
                                if (jsonObj.HostInfo.Profile == undefined || jsonObj.HostInfo.Profile == "") {
                                    jsonObj.HostInfo.Profile = data.Company;
                                }
                                if (jsonObj.HostInfo.Logo == undefined || jsonObj.HostInfo.Logo == "") {
                                    jsonObj.HostInfo.Logo = data.LoginAssets.logo;
                                }
                            }

                            jsonObj.EventInfo = {};
                            var startDate = moment.tz((field.EventInfo.EventStartDate ? field.EventInfo.EventStartDate : new Date()), field.EventInfo.TimeZone).format("YYYY-MM-DDTHH:mm:SS");
                            var endDate = moment.tz((field.EventInfo.EventEndDate ? field.EventInfo.EventEndDate : new Date()), field.EventInfo.TimeZone).format("YYYY-MM-DDTHH:mm:SS");

                            //jsonObj.EventInfo.BackgroundColor = field.EventInfo.BackgroundColor;
                            //jsonObj.EventInfo.BackgroundImage = field.EventInfo.BackgroundImage;
                            jsonObj.EventInfo.AllowRegistration = field.EventInfo.AllowRegistration == undefined ? false : field.EventInfo.AllowRegistration;
                            jsonObj.EventInfo.ExternalRegistrationEnabled = field.EventInfo.AllowRegistration && field.EventInfo.ExternalRegistrationEnabled ? true : false;
                            jsonObj.EventInfo.ExternalRegistrationLink = field.EventInfo.ExternalRegistrationLink ? field.EventInfo.ExternalRegistrationLink : null;
                            jsonObj.EventInfo.DateFormat = field.EventInfo.DateFormat ? field.EventInfo.DateFormat : 'dd MMM yyyy';
                            jsonObj.EventInfo.Description = field.EventInfo.Description;
                            jsonObj.EventInfo.EventStartDate = startDate; //field.EventInfo.EventStartDate;
                            jsonObj.EventInfo.EventEndDate = endDate; //field.EventInfo.EventEndDate;
                            jsonObj.EventInfo.EventFullName = field.EventInfo.EventFullName;
                            jsonObj.EventInfo.EventId = field.EventInfo.EventId;
                            jsonObj.EventInfo.EventLogo = field.EventInfo.EventLogo;
                            jsonObj.EventInfo.EventShortName = field.EventInfo.EventShortName;
                            jsonObj.EventInfo.EventTypeId = field.EventInfo.EventTypeId;
                            jsonObj.EventInfo.IsPublished = field.EventInfo.IsPublished == undefined ? true : field.EventInfo.IsPublished;
                            jsonObj.EventInfo.LobbyType = field.EventInfo.LobbyType == undefined ? 1 : field.EventInfo.LobbyType;
                            jsonObj.EventInfo.LocationType = field.EventInfo.LocationType;
                            jsonObj.EventInfo.ModifiedTime = field.EventInfo.ModifiedTime;
                            jsonObj.EventInfo.TimeZone = field.EventInfo.TimeZone;
                            jsonObj.EventInfo.Venue = field.EventInfo.Venue;
                            jsonObj.EventInfo.DefaultLandingURL = field.EventInfo.DefaultLandingURL;

                            if (jsonObj.EventInfo.DefaultLandingURL === undefined || jsonObj.EventInfo.DefaultLandingURL === null || jsonObj.EventInfo.DefaultLandingURL === "") {
                                jsonObj.EventInfo.DefaultLandingURL = '/lobby';
                            }

                            let path = field.EventCollectionName + '/Branding/';
                            let json = JSON.stringify(jsonObj, null, 2);
                            const blob = new Blob([json], { type: "application/json" });
                            let brandingName = "Branding_"+ new Date().getTime() +".json";
                            storageRef.child(path + brandingName).put(blob, { 'contentType': 'application/json' }).then(function (bSnap) {
                                bSnap.ref.getDownloadURL().then(function (bUrl) {
                                    let brandingJsonUrl = bUrl.toString();
                                    console.log(brandingJsonUrl)
                                    clientRef.doc(Session_Client_Id).collection('Events').doc(field.EventInfo.EventId).update({brandingJsonUrl:brandingJsonUrl}).then(function(){
                                        con.eventDB.collection(cn).doc('EventInfo').update({brandingJsonUrl:brandingJsonUrl}).then(function () {
                                            con.eventDB.collection(cn).doc('appBranding').set(jsonObj,{ merge: true }).then(function () {
                                                resolve("JSON updated")
                                            })
                                        })
                                    })
                                })                            
                            })
                            /*storageRef.child(path + "Branding.json").put(blob, { 'contentType': 'application/json' }).then(function (snapshot) {
                                resolve("JSON updated")
                            })*/

                        }).catch(function (error) {
                            //console.log('Error getting mapped client:', error)
                            //reject(error)
                        })
                    }
                })
            }).catch((err) => {
                // Didn't exist... or some other error
                //console.log(err)
                resolve(null)
            })
        })
    },
    fetchBrandingJson(context) {
        let path = cn + '/Branding/Branding.json';
        return new Promise((resolve, reject) => {
            con.eventDB.collection(cn).doc('EventInfo').get().then(function (doc) {  
                if(doc.exists && doc.data().brandingJsonUrl)  {              
                    // Found it. Do whatever
                    let brandingJsonUrl = doc.data().brandingJsonUrl;
                    axios.get(brandingJsonUrl).then(result => {
                        //console.log(typeof result.data)   
                        let jsonObj = null;
                        if (typeof result.data == 'string')
                            jsonObj = eval('(' + result.data + ')');
                        else if (typeof result.data == 'object')
                            jsonObj = result.data;
                        else
                            jsonObj = null;
                        if (jsonObj != null) {
                            jsonObj.uploadCustomLogoAndBanner = jsonObj.uploadCustomLogoAndBanner == undefined ? true : jsonObj.uploadCustomLogoAndBanner;
                        }
                        console.log(brandingJsonUrl)
                        resolve(jsonObj);
                    }).catch((err) => { resolve(null); });
                }
                else{
                    storageRef.child(path).getDownloadURL().then(function (url) {
                        let brandingJsonUrl = url.toString();
                        axios.get(brandingJsonUrl).then(result => {
                            //console.log(typeof result.data)   
                            let jsonObj = null;
                            if (typeof result.data == 'string')
                                jsonObj = eval('(' + result.data + ')');
                            else if (typeof result.data == 'object')
                                jsonObj = result.data;
                            else
                                jsonObj = null;
                            if (jsonObj != null) {
                                jsonObj.uploadCustomLogoAndBanner = jsonObj.uploadCustomLogoAndBanner == undefined ? true : jsonObj.uploadCustomLogoAndBanner;
                            }
                            resolve(jsonObj);
                        }).catch((err) => { resolve(null); });
                    }).catch((err) => {
                        resolve(null);
                    });
                }
            });
        });
    },
    uploadBrandingJsonHexCodeType(context, field) {
        return new Promise((resolve, reject) => {
            if (field.brandingJson) {
                let path = cn + '/Branding/';
                let jsonObj = JSON.parse(JSON.stringify(field.brandingJson, null, 2));
                jsonObj.uploadCustomLogoAndBanner = field.brandingJson.uploadCustomLogoAndBanner == undefined ? true : field.brandingJson.uploadCustomLogoAndBanner;
                jsonObj.postToCRM = field.EventInfo.postToCRM ? true : false;
                jsonObj.HideEventHeaderAndMenu = field.EventInfo.HideEventHeaderAndMenu ? true : false;
                jsonObj.EnableEmailOnlyLogin = field.EventInfo.EnableEmailOnlyLogin ? true : false;
                jsonObj.AllowPublicAccess = field.EventInfo.AllowPublicAccess ? true : false; 
                jsonObj.ShowProfileEditOnWelcome = field.EventInfo.ShowProfileEditOnWelcome ? true : false;
                jsonObj.AllowProfileEdit = field.EventInfo.AllowProfileEdit ? true : false;
                jsonObj.showAttendeePresenceBubble = field.EventInfo.showAttendeePresenceBubble ? true : false;
                jsonObj.WelcomeMessage = field.EventInfo.WelcomeMessage ? field.data.WelcomeMessage : null;
                jsonObj.DisableLanguageOption = field.EventInfo.DisableLanguageOption ? true : false;
                jsonObj.LogoutRedirectURL = field.EventInfo.LogoutRedirectURL ? field.data.LogoutRedirectURL : null;
                jsonObj.StreamingClient = field.EventInfo.StreamingClient ? field.EventInfo.StreamingClient : 'Zoom';
                jsonObj.approval_type = field.EventInfo.approval_type != undefined ? field.EventInfo.approval_type : 0;

                jsonObj.MetaTitle = field.EventInfo.MetaTitle ? field.EventInfo.MetaTitle : null;
                jsonObj.MetaDescription = field.EventInfo.MetaDescription ? field.EventInfo.MetaDescription : null;
                jsonObj.MetaKeywords = field.EventInfo.MetaKeywords ? field.EventInfo.MetaKeywords : null;
                jsonObj.MetaImage = field.EventInfo.MetaImage ? field.EventInfo.MetaImage : null;

                if (jsonObj.appColorHexCodeType == 'headerColorsHexCodeLight') {
                    jsonObj.headerColorsHexCode = {
                        "topBar": "#FFFFFF",
                        "headerBar": "#FFFFFF",
                        "fontBar": "#000000",
                        "sideNavigationAndIconColor": "#64656E"
                    }
                } else if (jsonObj.appColorHexCodeType == 'headerColorsHexCodeDark') {
                    jsonObj.headerColorsHexCode = {
                        "topBar": "#000000",
                        "headerBar": "#000000",
                        "fontBar": "#3a3a3a",
                        "sideNavigationAndIconColor": "#000000"
                    }
                }

                clientRef.doc(`${Session_Client_Id}`).get().then(function (doc) {
                    if (doc.exists) {
                        let data = doc.data()

                        if (jsonObj.ClientInfo == undefined) {
                            jsonObj.ClientInfo = {};
                        }

                        jsonObj.ClientInfo.ClientId = data.ClientId;
                        jsonObj.ClientInfo.ClientName = data.ClientName;
                        jsonObj.ClientInfo.LoginAssets = data.LoginAssets == undefined ? {} : data.LoginAssets;
                        jsonObj.ClientInfo.LastModifiedTime = data.LastModifiedTime;
                        jsonObj.ClientInfo.EventListAssets = data.EventListAssets == undefined ? {} : data.EventListAssets;
                        jsonObj.ClientInfo.Favicon = data.Favicon;
                        jsonObj.ClientInfo.AllowRegister = data.AllowRegister;
                        jsonObj.ClientInfo.SSOEnabled = data.SSOEnabled;
                        jsonObj.ClientInfo.SocialAuths = data.SocialAuths == undefined ? {} : data.SocialAuths;
                        jsonObj.ClientInfo.CustomDomain = data.CustomDomain;
                        jsonObj.ClientInfo.SSODomain = data.SSODomain;
                        jsonObj.ClientInfo.Company = data.Company;

                        var addHostFromClient = false;
                        if (jsonObj.HostInfo == undefined) {
                            jsonObj.HostInfo = {};
                            addHostFromClient = true;
                        } else if (jsonObj.HostInfo.Name == undefined || jsonObj.HostInfo.Profile == undefined || jsonObj.HostInfo.Logo == undefined) {
                            addHostFromClient = true;
                        }

                        if (addHostFromClient) {
                            jsonObj.HostInfo.Name = data.ClientName;
                            jsonObj.HostInfo.Profile = data.Company;
                            jsonObj.HostInfo.Logo = data.LoginAssets.logo;
                        }
                    }


                    //if (vm.BrandingJson.HostInfo == undefined) {
                    //    vm.BrandingJson.HostInfo = {};
                    //}
                    //if (res.HostInfo == undefined) {
                    //    vm.BrandingJson.HostInfo.Name = "";
                    //    vm.BrandingJson.HostInfo.Profile = "";
                    //    vm.BrandingJson.HostInfo.Logo = "";
                    //} else {
                    //    vm.BrandingJson.HostInfo.Name =
                    //        res.HostInfo.Name == undefined ? "" : res.HostInfo.Name;
                    //    vm.BrandingJson.HostInfo.Profile =
                    //        res.HostInfo.Profile == undefined ? "" : res.HostInfo.Profile;
                    //    vm.BrandingJson.HostInfo.Logo =
                    //        res.HostInfo.Logo == undefined ? "" : res.HostInfo.Logo;
                    //}

                    if (jsonObj.EventInfo == undefined) {
                        jsonObj.EventInfo = {};
                    }


                    var startDate = moment.tz((field.EventInfo.EventStartDate ? field.EventInfo.EventStartDate : new Date()), field.EventInfo.TimeZone).format("YYYY-MM-DDTHH:mm:SS");
                    var endDate = moment.tz((field.EventInfo.EventEndDate ? field.EventInfo.EventEndDate : new Date()), field.EventInfo.TimeZone).format("YYYY-MM-DDTHH:mm:SS");

                    //jsonObj.EventInfo.BackgroundColor = field.EventInfo.BackgroundColor;
                    //jsonObj.EventInfo.BackgroundImage = field.EventInfo.BackgroundImage;
                    // field.EventInfo.BackgroundImage = field.brandingJson.eventBGImage["2732x2048"]; 

                    jsonObj.EventInfo.AllowRegistration = field.EventInfo.AllowRegistration == undefined ? false : field.EventInfo.AllowRegistration;
                    jsonObj.EventInfo.ExternalRegistrationEnabled = field.EventInfo.AllowRegistration && field.EventInfo.ExternalRegistrationEnabled ? true : false;
                    jsonObj.EventInfo.ExternalRegistrationLink = field.EventInfo.ExternalRegistrationLink ? field.EventInfo.ExternalRegistrationLink : null;
                    jsonObj.EventInfo.DateFormat = field.EventInfo.DateFormat ? field.EventInfo.DateFormat : "dd MMM yyyy";
                    jsonObj.EventInfo.Description = field.EventInfo.Description;
                    jsonObj.EventInfo.EventStartDate = startDate; //field.EventInfo.EventStartDate;
                    jsonObj.EventInfo.EventEndDate = endDate; //field.EventInfo.EventEndDate;
                    jsonObj.EventInfo.EventFullName = field.EventInfo.EventFullName;
                    jsonObj.EventInfo.EventId = Session_Event_Id;
                    jsonObj.EventInfo.EventLogo = field.EventInfo.EventLogo == undefined ? "" : field.EventInfo.EventLogo;
                    jsonObj.EventInfo.BackgroundColor = field.EventInfo.BackgroundColor == undefined ? "" : field.EventInfo.BackgroundColor;
                    jsonObj.EventInfo.BackgroundImage = field.EventInfo.BackgroundImage == undefined ? "" : field.EventInfo.BackgroundImage;
                    jsonObj.EventInfo.BodyTextColor = field.EventInfo.BodyTextColor == undefined ? "" : field.EventInfo.BodyTextColor;
                    jsonObj.EventInfo.EventBanner = field.EventInfo.EventBanner == undefined ? "" : field.EventInfo.EventBanner;
                    jsonObj.EventInfo.EventBannerMobile = field.EventInfo.EventBannerMobile == undefined ? "" : field.EventInfo.EventBannerMobile;
                    jsonObj.EventInfo.EventBannerShare = field.EventInfo.EventBannerShare == undefined ? "" : field.EventInfo.EventBannerShare;
                    jsonObj.EventInfo.EventShortName = field.EventInfo.EventShortName;
                    jsonObj.EventInfo.EventTypeId = field.EventInfo.EventTypeId;
                    jsonObj.EventInfo.IsPublished = field.EventInfo.IsPublished == undefined ? true : field.EventInfo.IsPhed;
                    jsonObj.EventInfo.LobbyType = field.EventInfo.LobbyType == undefined ? 1 : field.EventInfo.LobbyType;
                    jsonObj.EventInfo.LocationType = field.EventInfo.LocationType;
                    jsonObj.EventInfo.ModifiedTime = field.EventInfo.ModifiedTime;
                    jsonObj.EventInfo.TimeZone = field.EventInfo.TimeZone;
                    jsonObj.EventInfo.Venue = field.EventInfo.Venue;
                    jsonObj.EventInfo.DefaultLandingURL = field.EventInfo.DefaultLandingURL;

                    if (jsonObj.EventInfo.DefaultLandingURL === undefined || jsonObj.EventInfo.DefaultLandingURL === null || jsonObj.EventInfo.DefaultLandingURL === "") {
                        jsonObj.EventInfo.DefaultLandingURL = '/lobby';
                    }

                    let json = JSON.stringify(jsonObj, null, 2);
                    const blob = new Blob([json], { type: "application/json" });
                    let brandingName = "Branding_"+ new Date().getTime() +".json";
                    console.log(jsonObj)
                    storageRef.child(path + brandingName).put(blob, { 'contentType': 'application/json' }).then(function (bSnap) {
                        bSnap.ref.getDownloadURL().then(function (bUrl) {
                            let brandingJsonUrl = bUrl.toString();
                            console.log(brandingJsonUrl)
                            clientRef.doc(Session_Client_Id).collection('Events').doc(Session_Event_Id).update({brandingJsonUrl:brandingJsonUrl}).then(function(){
                                con.eventDB.collection(cn).doc('EventInfo').update({brandingJsonUrl:brandingJsonUrl}).then(function () {
                                    con.eventDB.collection(cn).doc('appBranding').set(jsonObj,{ merge: true }).then(function () {
                                        resolve("JSON updated")
                                    })
                                }).catch(err=>{console.log(err)})
                            }).catch(err=>{console.log(err)})
                        })                            
                    })
                    /*storageRef.child(path + "Branding.json").put(blob, { 'contentType': 'application/json' }).then(function (snapshot) {
                        resolve("JSON updated");
                    })*/

                }).catch(function (error) {
                    //console.log('Error getting mapped client:', error)
                    //reject(error)
                })
            } else {
                resolve('')
            }
        })
    },
    uploadBrandingJsonColor(context, field) {
        return new Promise((resolve, reject) => {
            if (field.brandingJson) {
                let path = cn + '/Branding/';
                let json = JSON.stringify(field.brandingJson, null, 2);
                const blob = new Blob([json], { type: "application/json" });
                let brandingName = "Branding_"+ new Date().getTime() +".json";
                storageRef.child(path + brandingName).put(blob, { 'contentType': 'application/json' }).then(function (bSnap) {
                    bSnap.ref.getDownloadURL().then(function (bUrl) {
                        let brandingJsonUrl = bUrl.toString();
                        console.log(brandingJsonUrl)
                        clientRef.doc(Session_Client_Id).collection('Events').doc(Session_Event_Id).update({brandingJsonUrl:brandingJsonUrl}).then(function(){
                            con.eventDB.collection(cn).doc('EventInfo').update({brandingJsonUrl:brandingJsonUrl}).then(function () {
                                con.eventDB.collection(cn).doc('appBranding').set(field.brandingJson,{ merge: true }).then(function () {
                                    resolve("JSON updated")
                                })
                            })
                        })
                    })                            
                })
                /*storageRef.child(path + "Branding.json").put(blob, { 'contentType': 'application/json' }).then(function (snapshot) {
                    resolve("JSON updated")
                })*/

            } else {
                resolve('')
            }
        })
    },
    uploadBrandingJson(context, field) {
        return new Promise((resolve, reject) => {
            if (field.file && field.updateField) {
                let updateField = field.updateField
                let updateFieldName = field.filename
                let brandingJson = field.brandingJson
                let path = cn + '/Branding/';
                let file = field.file

                let extension = (file.name).split('.')
                let filename = field.filename+"_"+ new Date().getTime() + "." + extension[1]
                let metadata = {
                    'contentType': file.type
                }

                let Session_Event_Id = ls.getSessionValueByKey("Session_Event_Id")

                storageRef.child(path + filename).put(file, metadata).then(function (snapshot) {
                    snapshot.ref.getDownloadURL().then(function (url) {
                        brandingJson[updateField][updateFieldName] = url.toString()
                        //console.log(brandingJson)
                        let json = JSON.stringify(brandingJson, null, 2);
                        const blob = new Blob([json], { type: "application/json" });
                        let brandingName = "Branding_"+ new Date().getTime() +".json";
                        storageRef.child(path + brandingName).put(blob, { 'contentType': 'application/json' }).then(function (bSnap) {
                            bSnap.ref.getDownloadURL().then(function (bUrl) {
                                let brandingJsonUrl = bUrl.toString();
                                console.log(brandingJsonUrl)
                                clientRef.doc(Session_Client_Id).collection('Events').doc(Session_Event_Id).update({brandingJsonUrl:brandingJsonUrl}).then(function(){
                                    con.eventDB.collection(cn).doc('EventInfo').update({brandingJsonUrl:brandingJsonUrl}).then(function () {
                                        con.eventDB.collection(cn).doc('appBranding').set(brandingJson,{ merge: true }).then(function () {
                                            resolve(url.toString())
                                        })
                                    })
                                })
                            })                            
                        })

                    })
                }).catch((err) => { console.log(err) })

            } else {
                resolve('')
            }
        })
    },
    uploadBrandingJsonBlob(context, field) {
        return new Promise((resolve, reject) => {
            if (field.blob && field.updateField) {
                let updateField = field.updateField
                let updateFieldName = field.filename
                let brandingJson = field.brandingJson
                let path = cn + '/Branding/';
                let file = field.blob

                let extension = field.extension
                let filename = field.filename+"_"+ new Date().getTime() + "." + extension
                /*let metadata = {
                    'contentType': file.type
                }*/

                let Session_Event_Id = ls.getSessionValueByKey("Session_Event_Id")
                storageRef.child(path + filename).putString(file, 'data_url').then(function (snapshot) {
                    snapshot.ref.getDownloadURL().then(function (url) {
                        let uploadedFileUrl = url.toString()
                        console.log(uploadedFileUrl)
                        brandingJson[updateField][updateFieldName] = url.toString()
                        //console.log(brandingJson)
                        let json = JSON.stringify(brandingJson, null, 2);
                        const blob = new Blob([json], { type: "application/json" });
                        let brandingName = "Branding_"+ new Date().getTime() +".json";
                        storageRef.child(path + brandingName).put(blob, { 'contentType': 'application/json' }).then(function (bSnap) {
                            bSnap.ref.getDownloadURL().then(function (bUrl) {
                                let brandingJsonUrl = bUrl.toString();
                                console.log(brandingJsonUrl)
                                clientRef.doc(Session_Client_Id).collection('Events').doc(Session_Event_Id).update({brandingJsonUrl:brandingJsonUrl}).then(function(){
                                    con.eventDB.collection(cn).doc('EventInfo').update({brandingJsonUrl:brandingJsonUrl}).then(function () {
                                        con.eventDB.collection(cn).doc('appBranding').set(brandingJson,{ merge: true }).then(function () {
                                            resolve({brandingJsonUrl:url.toString(), uploadedFileUrl: uploadedFileUrl})
                                        })
                                    })
                                })
                            })                            
                        })

                    })
                }).catch((err) => { console.log(err) })

            } else {
                reject('')
            }
        })
    },
    deleteBrandingJson(context, field) {
        return new Promise((resolve, reject) => {
            if (field.filename && field.updateField) {
                let updateField = field.updateField
                let updateFieldName = field.filename
                let brandingJson = field.brandingJson
                let path = cn + '/Branding/';
                let Session_Event_Id = ls.getSessionValueByKey('Session_Event_Id');

                brandingJson[updateField][updateFieldName] = ""
                let json = JSON.stringify(brandingJson, null, 2);
                const blob = new Blob([json], { type: "application/json" });

                let brandingName = "Branding_"+ new Date().getTime() +".json";                        

                storageRef.child(path + brandingName).put(blob, { 'contentType': 'application/json' }).then(function (bSnap) {
                    bSnap.ref.getDownloadURL().then(function (bUrl) {
                        let brandingJsonUrl = bUrl.toString();
                        let docObj = new Object
                        if (updateField == 'eventLogo' && updateFieldName == '960x192') docObj.EventLogo = ""
                        if (updateField == 'eventBGImage' && updateFieldName == '2732x2048') docObj.BackgroundImage = ""
                        if (updateField == 'banner' && updateFieldName == '2048x88') docObj.EventBanner = ""
                        docObj.brandingJsonUrl = brandingJsonUrl;
                        if (Object.keys(docObj).length) {
                            con.eventDB.collection(cn).doc('EventInfo').update(docObj).then(function () {
                                con.instanceDB.doc('ClientList').collection('Clients').doc(Session_Client_Id).collection('Events').doc(Session_Event_Id).update(docObj).then(function () { })
                            })
                        }
                        con.eventDB.collection(cn).doc('appBranding').set(brandingJson,{ merge: true }).then(function () {
                         resolve({ status: 200, message: 'Json Updated.' })
                        })
                    })
                })
            } else {
                resolve({ status: 500, message: 'Failed to Update Json.' })
            }
        })
    },
    setBarndingAsDefault(context, brandingJson) {
        return new Promise((resolve, reject) => {
            if (brandingJson) {
                let path = `OA_UAT/Clients/${Session_Client_Id}/`;
                let json = JSON.stringify(brandingJson, null, 2);
                const blob = new Blob([json], { type: "application/json" });
                let brandingName = "DefaultBranding.json";
                storageRef.child(path + brandingName).put(blob, { 'contentType': 'application/json' }).then(function (bSnap) {
                    bSnap.ref.getDownloadURL().then(function (bUrl) {
                        let brandingJsonUrl = bUrl.toString();
                        console.log(brandingJsonUrl)
                        clientRef.doc(Session_Client_Id).update({defaultBrandingJsonUrl:brandingJsonUrl}).then(function(){
                            resolve('Json URL Updated');
                        })
                    })                            
                })

            } else {
                reject('Provide valid JSON!')
            }
        })
    },
    getClientsDefaultBrandingJson(context) {
        return new Promise((resolve, reject) => {
            clientRef.doc(Session_Client_Id).get().then(function (doc) {  
                if(doc.exists && doc.data().defaultBrandingJsonUrl)  {              
                    // Found it. Do whatever
                    let brandingJsonUrl = doc.data().defaultBrandingJsonUrl;
                    axios.get(brandingJsonUrl).then(result => {
                        //console.log(typeof result.data)   
                        let jsonObj = null;
                        if (typeof result.data == 'string')
                            jsonObj = eval('(' + result.data + ')');
                        else if (typeof result.data == 'object')
                            jsonObj = result.data;
                        else
                            jsonObj = null;                        
                        resolve(jsonObj);
                    }).catch((err) => { resolve(null); });
                }
                else{
                    storageRef.child(`/OA_UAT/Defaults/Branding.json`).getDownloadURL().then(function (url) {
                        let brandingJsonUrl = url.toString();
                        axios.get(brandingJsonUrl).then(result => {
                            //console.log(typeof result.data)   
                            let jsonObj = null;
                            if (typeof result.data == 'string')
                                jsonObj = eval('(' + result.data + ')');
                            else if (typeof result.data == 'object')
                                jsonObj = result.data;
                            else
                                jsonObj = null;
                            resolve(jsonObj);
                        }).catch((err) => { resolve(null); });
                    }).catch((err) => {
                        resolve(null);
                    });
                }
            });
        });
    },
    fetchClientFeatures(context) {
        return new Promise((resolve, reject) => {
            clientRef.doc(Session_Client_Id).collection('Features').doc('ClientFeatures').get().then(function (clientFeatures) {
                let resultFeatures = (clientFeatures.exists ? clientFeatures.data().Features : []);
                resultFeatures.forEach(feature => {
                    feature.selected = feature.IsDefault ? true : false;
                });
                resultFeatures.sort(function (a, b) {
                    return (
                        a.selected > b.selected ? -1 : a.selected < b.selected ? 1 : 0
                    );
                });
                resolve({ status: 200, AllFeatures: resultFeatures });
            });
        });
    },
    fetchEventFeatures(context, id) {
        return new Promise((resolve, reject) => {
            if (id) {
                let resultFeatures = []
                con.instanceDB.doc("Features").get().then(function (instanceFeaturesQ) {
                    let instanceFeatures = (instanceFeaturesQ.exists ? instanceFeaturesQ.data().Features : []);
                    clientRef.doc(Session_Client_Id).collection('Features').doc('ClientFeatures').get().then(function (clientFeatures) {
                        let allFeatures = (clientFeatures.exists ? clientFeatures.data().Features : []);
                        var oldFeatures = allFeatures.filter(function (value) {
                            return value.IsDefault == undefined;
                        });
                        con.eventDB.collection(cn).doc('Features').get().then(function (eventFeature) {
                            let selectedFeatures = (eventFeature.exists ? eventFeature.data().Features : []);
                            let availableFeatures = [];
                            if (selectedFeatures.length > allFeatures.length) {
                                availableFeatures = selectedFeatures;
                            } else {
                                availableFeatures = allFeatures;
                                selectedFeatures.forEach(srow => {
                                    let found = allFeatures.some(el => el.ID === srow.ID)
                                    if (!found) {
                                        availableFeatures.push(srow);
                                    }
                                });
                            }
                            if (selectedFeatures.length == 0) {
                                if (oldFeatures.length > 0) {
                                    availableFeatures.forEach(feature => {
                                        if (feature.IsDefault == undefined) {
                                            instanceFeatures.forEach(instanceFeature => {
                                                if (feature.ID == instanceFeature.ID) {
                                                    var isDefault = (instanceFeature.IsDefault ? true : false);
                                                    if (isDefault) {
                                                        feature.IsDefault = true;
                                                    }
                                                }
                                            });
                                        }
                                        //resultFeatures.push(feature);
                                    });
                                }
                                availableFeatures.forEach(feature => {
                                    feature.selected = (feature.IsDefault ? true : false);
                                    resultFeatures.push(feature);
                                });
                            } else {
                                availableFeatures.forEach(feature => {
                                    let found = selectedFeatures.some(el => el.ID === feature.ID);
                                    feature.selected = (found ? true : false);
                                    resultFeatures.push(feature);
                                });
                            }
                            resultFeatures.forEach(feature => {
                                var isDefault = (feature.IsDefault ? true : false);
                                if (isDefault) {
                                    feature.selected = true;
                                }
                            });
                            resultFeatures.sort(function (a, b) {
                                return (
                                    a.selected > b.selected ? -1 : a.selected < b.selected ? 1 : 0
                                );
                            });
                            resolve({ status: 200, AllFeatures: resultFeatures });
                        })
                    });
                });
            }
        });
    },
    updateEventFeatures(context, field) {
        return new Promise((resolve, reject) => {
            let selectedFeatures = [];
            field.SelectedFeatures.forEach(feature => {
                if (feature.selected) {
                    selectedFeatures.push({ ID: feature.ID, Name: feature.Name , Color: feature.color == null ? '' : feature.color})
                }
            });
            con.eventDB.collection(cn).doc('Features').get().then(function (doc) {
                if (doc.exists) {
                    con.eventDB.collection(cn).doc('Features').update({
                        Features: selectedFeatures,
                        ModifiedTime: new Date()
                    }).then(function () {
                        let Session_Event_Id = ls.getSessionValueByKey("Session_Event_Id");
                        context.dispatch('AddDefaultFeatureMenu', { id: Session_Event_Id, features: selectedFeatures }).then(function () {
                            resolve({ status: 200, message: "Features Created" })
                        });
                    });
                } else {
                    con.eventDB.collection(cn).doc('Features').set({
                        Features: selectedFeatures,
                        CreatedTime: new Date(),
                        ModifiedTime: new Date()
                    }).then(function () {
                        let Session_Event_Id = ls.getSessionValueByKey("Session_Event_Id");
                        context.dispatch('AddDefaultFeatureMenu', { id: Session_Event_Id, features: selectedFeatures }).then(function () {
                            resolve({ status: 200, message: "Features Created" })
                        });
                    });
                }
            });
        });
    },
    fetchEventMenu(context, id) {
        return new Promise((resolve, reject) => {
            if (id) {
                let AvailableMenu = [];
                let ShowNotification = true;
                con.eventDB.collection(cn).doc('Features').get().then(function (selectedfeature) {
                    con.eventDB.collection(cn).doc('Menu').get().then(function (selectedmenu) {
                        if (selectedmenu.exists) {
                            ShowNotification = (selectedmenu.data().ShowNotification != undefined ? selectedmenu.data().ShowNotification : true);
                        }

                        let Features = (selectedfeature.exists ? selectedfeature.data().Features : []);
                        let SelectedMenu = (selectedmenu.exists ? selectedmenu.data().AllMenu : []);
                        let SelectedLeftMenu = (selectedmenu.exists ? selectedmenu.data().LeftMenu : []);
                        con.instanceDB.doc("Menu").get().then(function (menu) {
                            menu.data().AllMenu.forEach(menurow => {
                                let found = Features.some(el => el.ID === menurow.FeatureID && menurow.IsPublished && (menurow.PositionInPage == 1 || menurow.PositionInPage == 4));
                                if (found) {
                                    AvailableMenu.push(menurow);
                                }
                            });
                            AvailableMenu.sort(function (a, b) {
                                return (
                                    a.DisplayOrder - b.DisplayOrder
                                );
                            });
                            resolve({ status: 200, AvailableMenu: AvailableMenu, SelectedMenu: SelectedMenu, SelectedLeftMenu: SelectedLeftMenu, ShowNotification: ShowNotification });
                        })
                    })
                }).catch(function (error) {
                    console.log('Error getting mappe:', error);
                    reject(error);
                })
            }
        })
    },
    fetchEventAppMenu(context) {
        return new Promise((resolve, reject) => {
            let ShowAppNotification = true;
            let SelectedBottomMenu = [];
            let SelectedHamburgerMenu = [];
            let SelectedLobbyMenu = [];
            con.eventDB.collection(cn).doc('AppMenu').get().then(function (selectedmenu) {
                if (selectedmenu.exists){
                    ShowAppNotification = (selectedmenu.data().ShowAppNotification != undefined ? selectedmenu.data().ShowAppNotification : true);                        

                    SelectedBottomMenu = (selectedmenu.data().BottomMenu ? selectedmenu.data().BottomMenu : []);
                    SelectedHamburgerMenu = (selectedmenu.data().HamburgerMenu ? selectedmenu.data().HamburgerMenu : []);
                    SelectedLobbyMenu = (selectedmenu.data().LobbyMenu ? selectedmenu.data().LobbyMenu : []);                            
                }
                resolve({ status: 200, SelectedBottomMenu: SelectedBottomMenu, SelectedHamburgerMenu: SelectedHamburgerMenu, SelectedLobbyMenu: SelectedLobbyMenu, ShowAppNotification: ShowAppNotification });
            })                
        })
    },
    AddDefaultFeatureMenu(context, fields) {
        return new Promise((resolve, reject) => {
            if (fields.id) {
                context.dispatch('fetchEventMenu', fields.id).then(function (allMenu) {
                    var topMenuList = allMenu.SelectedMenu == undefined ? [] : allMenu.SelectedMenu;
                    var leftMenuList = allMenu.SelectedLeftMenu == undefined ? [] : allMenu.SelectedLeftMenu;
                    if (topMenuList.length == 0 && leftMenuList.length == 0) {
                        fields.features.forEach(feature => {
                            allMenu.AvailableMenu.forEach(menu => {
                                if (menu.FeatureID == feature.ID) {
                                    var positionInPage = menu.PositionInPage == undefined ? 0 : menu.PositionInPage;
                                    //if (positionInPage == 1 || positionInPage == 0) {
                                    if (positionInPage == 1) {
                                        topMenuList.push(menu);
                                    } else if (positionInPage == 4) {
                                        leftMenuList.push(menu);
                                    }
                                }
                            });
                        });
                        if (topMenuList.length > 0 || leftMenuList.length > 0) {
                            topMenuList.sort(function (a, b) {
                                return (
                                    a.DisplayOrder - b.DisplayOrder
                                );
                            });
                            leftMenuList.sort(function (a, b) {
                                return (
                                    a.DisplayOrder - b.DisplayOrder
                                );
                            });
                            context.dispatch('updateEventMenu', {
                                SelectedMenu: topMenuList,
                                SelectedLeftMenu: leftMenuList,
                                ShowNotification: false,
                                ModifiedTime: new Date()
                            }).then(function (allMenu) {
                                resolve({ status: 200, message: "Features Created" });
                            });
                        }
                    } else {
                        resolve({ status: 200, message: "Features Created" });
                    }
                });
            }
        });
    },
    updateEventMenu(context, field) {
        return new Promise((resolve, reject) => {
            con.eventDB.collection(cn).doc('Menu').get().then(function (doc) {
                if (doc.exists) {
                    con.eventDB.collection(cn).doc('Menu').update({
                        AllMenu: field.SelectedMenu,
                        LeftMenu: field.SelectedLeftMenu,
                        ShowNotification: field.ShowNotification,
                        ModifiedTime: new Date()
                    }).then(function () {
                        resolve({ status: 200, message: "Menu Updated" });
                    })
                } else {
                    con.eventDB.collection(cn).doc('Menu').set({
                        AllMenu: field.SelectedMenu,
                        LeftMenu: field.SelectedLeftMenu,
                        ShowNotification: field.ShowNotification,
                        CreatedTime: new Date(),
                        ModifiedTime: new Date()
                    }).then(function () {
                        resolve({ status: 200, message: "Menu Created" });
                    });
                }
            });
        });
    },
    updateEventAppMenu(context, field) {
        return new Promise((resolve, reject) => {
            con.eventDB.collection(cn).doc('AppMenu').get().then(function (doc) {
                if (doc.exists) {
                    con.eventDB.collection(cn).doc('AppMenu').update({
                        BottomMenu: field.SelectedBottomMenu,
                        HamburgerMenu: field.SelectedHamburgerMenu,
                        LobbyMenu: field.SelectedLobbyMenu,
                        ShowAppNotification: field.ShowAppNotification,
                        ModifiedTime: new Date()
                    }).then(function () {
                        resolve({ status: 200, message: "App Menu Updated" });
                    })
                } else {
                    con.eventDB.collection(cn).doc('AppMenu').set({
                        BottomMenu: field.SelectedBottomMenu,
                        HamburgerMenu: field.SelectedHamburgerMenu,
                        SelectedLobbyMenu: field.SelectedLobbyMenu,
                        ShowAppNotification: field.ShowAppNotification,
                        CreatedTime: new Date(),
                        ModifiedTime: new Date()
                    }).then(function () {
                        resolve({ status: 200, message: "App Menu Created" });
                    });
                }
            });
        });
    },
    updateEventMenuTheme(context, theme) {
        return new Promise((resolve, reject) => {
            //theme
            con.eventDB.collection(cn).doc('Menu').get().then(function (doc) {
                if (doc.exists) {
                    var data = doc.data();
                    var AllMenu = data.AllMenu == undefined ? [] : data.AllMenu;
                    var LeftMenu = data.LeftMenu == undefined ? [] : data.LeftMenu;
                    var ShowNotification = data.ShowNotification == undefined ? false : data.ShowNotification;

                    AllMenu.forEach(function (menu) {
                        if (theme == "dark") {
                            menu.IconUrl = menu.IconUrl.replace("/light/", "/dark/");
                            menu.IconUrl = menu.IconUrl.replace("%2Flight%2F", "%2Fdark%2F");
                        } else if (theme == "light") {
                            menu.IconUrl = menu.IconUrl.replace("/dark/", "/light/");
                            menu.IconUrl = menu.IconUrl.replace("/dark/", "/light/");
                            menu.IconUrl = menu.IconUrl.replace("%2Fdark%2F", "%2Flight%2F");
                        }
                    });
                    LeftMenu.forEach(function (menu) {
                        if (theme == "dark") {
                            menu.IconUrl = menu.IconUrl.replace("/light/", "/dark/");
                            menu.IconUrl = menu.IconUrl.replace("%2Flight%2F", "%2Fdark%2F");
                        } else if (theme == "light") {
                            menu.IconUrl = menu.IconUrl.replace("/dark/", "/light/");
                            menu.IconUrl = menu.IconUrl.replace("%2Fdark%2F", "%2Flight%2F");
                        }
                    });

                    con.eventDB.collection(cn).doc('Menu').update({
                        AllMenu: AllMenu,
                        LeftMenu: LeftMenu,
                        ShowNotification: ShowNotification,
                        ModifiedTime: new Date()
                    }).then(function () {
                        resolve({ status: 200, message: "Menu Updated" })
                    });
                }
                //else {
                //    con.eventDB.collection(cn).doc('Menu').set({
                //        AllMenu: field.SelectedMenu,
                //        LeftMenu: field.SelectedLeftMenu,
                //        ShowNotification: field.ShowNotification,
                //        CreatedTime: new Date(),
                //        ModifiedTime: new Date()
                //    }).then(function() {
                //        resolve({ status: 200, message: "Menu Created" })
                //    })
                //}
            });
        });
    },
    updateMenuIcon(context, field) {
        return new Promise((resolve, reject) => {
            let file = field.file
            let metadata = {
                'contentType': file.type
            }
            storageRef.child(cn + '/MenuIcons/' + (new Date().getTime()) + "_" + file.name).put(file, metadata).then(function (snapshot) {
                snapshot.ref.getDownloadURL().then(function (url) {
                    resolve(url.toString())
                })
            })
        }).catch((err) => { resolve(null) })
    },
    removeRecord({ commit }, userId) {
        return new Promise((resolve, reject) => {
            axios.delete(`/api/user-management/users/${userId}`)
                .then((response) => {
                    commit('REMOVE_RECORD', userId)
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },
    SetTimeByZone: function (strDateTime, timeZone) {
        var date = moment.tz(strDateTime, timeZone).format("MM/DD/YYYY HH:mm");
        return date;
    },
    addUpdatePlugin(context, field) {
        return new Promise((resolve, reject) => {
            let docObj = new Object
            eventRef.get().then(function (doc) {
                docObj = doc.data();
                if (docObj.Plugins != undefined) {
                    if (field.data != null) {
                        if (docObj.Plugins.SocialWall != undefined && docObj.Plugins.InfoDesk != undefined) {
                            var SocialWall = docObj.Plugins.SocialWall;
                            var InfoDesk = docObj.Plugins.InfoDesk;
                            enableFlg = field.data.enableDisableFlg == "Disable" ? false : true;
                            var chatOnFlag = field.data.OneToOneChat ? field.data.OneToOneChat : false;
                            con.eventDB.collection(cn).doc('EventInfo').update({
                                Plugins: { HelpChat: {isEnabled: enableFlg },OneToOneChat:{IsEnabled: chatOnFlag,defaultChatMsg:field.data.defaultChatMsg} , SocialWall, InfoDesk }
                            }).then(function (doc) {
                                resolve({ status: 200, message: "Plugin Added/Updated" })
                            })
                        } else if (docObj.Plugins.SocialWall != undefined) {
                            var SocialWall = docObj.Plugins.SocialWall;
                            enableFlg = field.data.enableDisableFlg == "Disable" ? false : true;
                            var chatOnFlag = field.data.OneToOneChat ? field.data.OneToOneChat : false;
                            con.eventDB.collection(cn).doc('EventInfo').update({
                                Plugins: { HelpChat: { isEnabled: enableFlg },OneToOneChat:{IsEnabled: chatOnFlag,defaultChatMsg:field.data.defaultChatMsg}, SocialWall }
                            }).then(function (doc) {
                                resolve({ status: 200, message: "Plugin Added/Updated" })
                            })
                        } else if (docObj.Plugins.InfoDesk != undefined) {
                            var InfoDesk = docObj.Plugins.InfoDesk;
                            var chatPlugin = docObj.Plugins.OneToOneChat;
                            enableFlg = field.data.enableDisableFlg == "Disable" ? false : true;
                            var HelpChatPlugin = docObj.Plugins.HelpChat;
                            var chatOnFlag = field.data.OneToOneChat ? field.data.OneToOneChat : false;
                            var InfochatFlag = field.data.InfoPageShowLiveHelpChatPanel == "Disable" ? false : true;
                            con.eventDB.collection(cn).doc('EventInfo').update({
                                Plugins: { HelpChat: {isEnabled: enableFlg },OneToOneChat:{IsEnabled: chatOnFlag,defaultChatMsg:field.data.defaultChatMsg ? field.data.defaultChatMsg : chatPlugin.defaultChatMsg ? chatPlugin.defaultChatMsg : "Hi 👋" }, InfoDesk: { InfoPageBackgroundImage: field.data.InfoPageBackgroundImage ? field.data.InfoPageBackgroundImage: InfoDesk.InfoPageBackgroundImage, InfoPageShowLiveHelpChatPanel: InfochatFlag } }
                            }).then(function (doc) {
                                resolve({ status: 200, message: "Plugin Added/Updated" })
                            })
                        } else if (docObj.Plugins.OneToOneChat != undefined) {
                            var OneToOneChat = docObj.Plugins.OneToOneChat;
                            var InfoDesk = docObj.Plugins.InfoDesk;
                            enableFlg = field.data.enableDisableFlg == "Disable" ? false : true;
                            var InfochatFlag = field.data.InfoPageShowLiveHelpChatPanel == "Disable" ? false : true;
                            var HelpChatPlugin = docObj.Plugins.HelpChat;
                            con.eventDB.collection(cn).doc('EventInfo').update({
                                Plugins: { HelpChat: {isEnabled: enableFlg }, OneToOneChat,InfoDesk: { InfoPageBackgroundImage: field.data.InfoPageBackgroundImage ? field.data.InfoPageBackgroundImage: InfoDesk ? InfoDesk.InfoPageBackgroundImage : 'https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2Fhelpdesk-bg.jpg?alt=media', InfoPageShowLiveHelpChatPanel: InfochatFlag } }
                            }).then(function (doc) {
                                resolve({ status: 200, message: "Plugin Added/Updated" })
                            })
                        }
                        else {
                            enableFlg = field.data.enableDisableFlg == "Disable" ? false : true;
                            con.eventDB.collection(cn).doc('EventInfo').update({
                                Plugins: { HelpChat: { isEnabled: enableFlg }, OneToOneChat: { IsEnabled: field.data.OneToOneChat, defaultChatMsg: field.data.defaultChatMsg } }
                            }).then(function (doc) {
                                resolve({ status: 200, message: "Plugin Added/Updated" })
                            })
                        }
                    } else if (field.data.InfoPageBackgroundImage != undefined) {
                        if (docObj.Plugins.SocialWall != undefined && docObj.Plugins.HelpChat != undefined) {
                            var SocialWall = docObj.Plugins.SocialWall;
                            var HelpChat = docObj.Plugins.HelpChat;
                            enableFlg = field.data.InfoPageShowLiveHelpChatPanel == "Disable" ? false : true;
                            con.eventDB.collection(cn).doc('EventInfo').update({
                                Plugins: { HelpChat, SocialWall, InfoDesk: { InfoPageBackgroundImage: field.data.InfoPageBackgroundImage, InfoPageShowLiveHelpChatPanel: enableFlg } }
                            }).then(function (doc) {
                                resolve({ status: 200, message: "Plugin Added/Updated" })
                            })
                        } else if (docObj.Plugins.HelpChat != undefined) {
                            var HelpChat = docObj.Plugins.HelpChat;
                            enableFlg = field.data.InfoPageShowLiveHelpChatPanel == "Disable" ? false : true;
                            con.eventDB.collection(cn).doc('EventInfo').update({
                                Plugins: { InfoDesk: { InfoPageBackgroundImage: field.data.InfoPageBackgroundImage, InfoPageShowLiveHelpChatPanel: enableFlg }, HelpChat }
                            }).then(function (doc) {
                                resolve({ status: 200, message: "Plugin Added/Updated" })
                            })
                        } else if (docObj.Plugins.SocialWall != undefined) {
                            var SocialWall = docObj.Plugins.SocialWall;
                            enableFlg = field.data.InfoPageShowLiveHelpChatPanel == "Disable" ? false : true;
                            con.eventDB.collection(cn).doc('EventInfo').update({
                                Plugins: { InfoDesk: { InfoPageBackgroundImage: field.data.InfoPageBackgroundImage, InfoPageShowLiveHelpChatPanel: enableFlg }, SocialWall }
                            }).then(function (doc) {
                                resolve({ status: 200, message: "Plugin Added/Updated" })
                            })
                        } else if (docObj.Plugins.OneToOneChat != undefined) {
                            var OneToOneChat = docObj.Plugins.OneToOneChat;
                            enableFlg = field.data.enableDisableFlg == "Disable" ? false : true;
                            con.eventDB.collection(cn).doc('EventInfo').update({
                                Plugins: { InfoDesk: { InfoPageBackgroundImage: field.data.InfoPageBackgroundImage, InfoPageShowLiveHelpChatPanel: enableFlg }, OneToOneChat }
                            }).then(function (doc) {
                                resolve({ status: 200, message: "Plugin Added/Updated" })
                            })
                        }
                        else {
                            enableFlg = field.data.InfoPageShowLiveHelpChatPanel == "Disable" ? false : true;
                            con.eventDB.collection(cn).doc('EventInfo').update({
                                Plugins: { InfoDesk: { InfoPageBackgroundImage: field.data.InfoPageBackgroundImage, InfoPageShowLiveHelpChatPanel: enableFlg }, OneToOneChat: { IsEnabled: field.data.OneToOneChat,defaultChatMsg: field.data.defaultChatMsg } }
                            }).then(function (doc) {
                                resolve({ status: 200, message: "Plugin Added/Updated" })
                            })
                        }
                    } else if (field.data.OneToOneChat != undefined) {
                        if (docObj.Plugins.SocialWall != undefined && docObj.Plugins.HelpChat != undefined && docObj.Plugins.InfoDesk != undefined) {
                            var SocialWall = docObj.Plugins.SocialWall;
                            var HelpChat = docObj.Plugins.HelpChat;
                            con.eventDB.collection(cn).doc('EventInfo').update({
                                Plugins: { HelpChat, SocialWall, InfoDesk, OneToOneChat: { IsEnabled: field.data.OneToOneChat,defaultChatMsg: field.data.defaultChatMsg } }
                            }).then(function (doc) {
                                resolve({ status: 200, message: "Plugin Added/Updated" })
                            })
                        } else if (docObj.Plugins.HelpChat != undefined) {
                            var HelpChat = docObj.Plugins.HelpChat;
                            con.eventDB.collection(cn).doc('EventInfo').update({
                                Plugins: { OneToOneChat: { IsEnabled: field.data.OneToOneChat,defaultChatMsg: field.data.defaultChatMsg }, HelpChat }
                            }).then(function (doc) {
                                resolve({ status: 200, message: "Plugin Added/Updated" })
                            })
                        } else if (docObj.Plugins.SocialWall != undefined) {
                            var SocialWall = docObj.Plugins.SocialWall;
                            con.eventDB.collection(cn).doc('EventInfo').update({
                                Plugins: { OneToOneChat: { IsEnabled: field.data.OneToOneChat,defaultChatMsg: field.data.defaultChatMsg }, SocialWall }
                            }).then(function (doc) {
                                resolve({ status: 200, message: "Plugin Added/Updated" })
                            })
                        } else if (docObj.Plugins.InfoDesk != undefined) {
                            var InfoDesk = docObj.Plugins.InfoDesk;
                            var chatPlugin = docObj.Plugins.OneToOneChat;
                            enableFlg = field.data.InfoPageShowLiveHelpChatPanel == "Disable" ? false : true;
                            con.eventDB.collection(cn).doc('EventInfo').update({
                                Plugins: { OneToOneChat: { IsEnabled: field.data.OneToOneChat,defaultChatMsg: field.data.defaultChatMsg ? field.data.defaultChatMsg : chatPlugin.defaultChatMsg ? defaultChatMsg : "Hi 👋" }, InfoDesk: { InfoPageBackgroundImage: field.data.InfoPageBackgroundImage ? field.data.InfoPageBackgroundImage : InfoDesk.InfoPageBackgroundImage, InfoPageShowLiveHelpChatPanel: enableFlg } }
                            }).then(function (doc) {
                                resolve({ status: 200, message: "Plugin Added/Updated" })
                            })
                        }
                        else {
                            con.eventDB.collection(cn).doc('EventInfo').update({
                                Plugins: { OneToOneChat: { IsEnabled: field.data.OneToOneChat,defaultChatMsg: field.data.defaultChatMsg } }
                            }).then(function (doc) {
                                resolve({ status: 200, message: "Plugin Added/Updated" })
                            })
                        }
                    }
                    else {
                        if (docObj.Plugins.HelpChat != undefined && docObj.Plugins.InfoDesk != undefined) {
                            var HelpChat = docObj.Plugins.HelpChat;
                            var InfoDesk = docObj.Plugins.InfoDesk;
                            enableFlg = field.data.enableDisableFlg == "Disable" ? false : true;
                            con.eventDB.collection(cn).doc('EventInfo').update({
                                Plugins: { SocialWall: { EmbedCode: field.data.embededCode, isEnabled: enableFlg }, HelpChat, InfoDesk }
                            }).then(function (doc) {
                                resolve({ status: 200, message: "Plugin Added/Updated" })
                            })
                        } else if (docObj.Plugins.HelpChat != undefined) {
                            var HelpChat = docObj.Plugins.HelpChat;
                            enableFlg = field.data.enableDisableFlg == "Disable" ? false : true;
                            con.eventDB.collection(cn).doc('EventInfo').update({
                                Plugins: { SocialWall: { EmbedCode: field.data.embededCode, isEnabled: enableFlg }, HelpChat }
                            }).then(function (doc) {
                                resolve({ status: 200, message: "Plugin Added/Updated" })
                            })
                        } else if (docObj.Plugins.InfoDesk != undefined) {
                            var InfoDesk = docObj.Plugins.InfoDesk;
                            enableFlg = field.data.InfoPageShowLiveHelpChatPanel == "Disable" ? false : true;
                            con.eventDB.collection(cn).doc('EventInfo').update({
                                Plugins: { SocialWall: { EmbedCode: field.data.embededCode, isEnabled: enableFlg } , InfoDesk: { InfoPageBackgroundImage: field.data.InfoPageBackgroundImage ? field.data.InfoPageBackgroundImage : InfoDesk.InfoPageBackgroundImage, InfoPageShowLiveHelpChatPanel: enableFlg } }
                            }).then(function (doc) {
                                resolve({ status: 200, message: "Plugin Added/Updated" })
                            })
                        } else if (docObj.Plugins.OneToOneChat != undefined) {
                            var OneToOneChat = docObj.Plugins.OneToOneChat;
                            con.eventDB.collection(cn).doc('EventInfo').update({
                                Plugins: { SocialWall: { EmbedCode: field.data.embededCode, isEnabled: enableFlg }, OneToOneChat }
                            }).then(function (doc) {
                                resolve({ status: 200, message: "Plugin Added/Updated" })
                            })
                        }
                        else {
                            enableFlg = field.data.enableDisableFlg == "Disable" ? false : true;
                            con.eventDB.collection(cn).doc('EventInfo').update({
                                Plugins: { SocialWall: { EmbedCode: field.data.embededCode, isEnabled: enableFlg } }
                            }).then(function (doc) {
                                resolve({ status: 200, message: "Plugin Added/Updated" })
                            })
                        }
                    }

                } else {
                    var enableFlg;
                    if (field.data != undefined) {
                        enableFlg = field.data.enableDisableFlg == "Disable" ? false : true;
                        var helpChatFlgInfo = field.data.InfoPageShowLiveHelpChatPanel == "Disable" ? false : true
                        con.eventDB.collection(cn).doc('EventInfo').update({
                            Plugins: { HelpChat: { isEnabled: enableFlg }, OneToOneChat: { IsEnabled: field.data.OneToOneChat,defaultChatMsg: field.data.defaultChatMsg },InfoDesk: { InfoPageBackgroundImage: field.data.InfoPageBackgroundImage ? field.data.InfoPageBackgroundImage : "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2Fhelpdesk-bg.jpg?alt=media", InfoPageShowLiveHelpChatPanel: helpChatFlgInfo } }
                        }).then(function (doc) {
                            resolve({ status: 200, message: "Plugin Added/Updated" })
                        })
                    } else if (field.data.InfoPageBackgroundImage != undefined) {
                        enableFlg = field.data.InfoPageShowLiveHelpChatPanel == "Disable" ? false : true;
                        con.eventDB.collection(cn).doc('EventInfo').update({
                            Plugins: { InfoDesk: { InfoPageBackgroundImage: field.data.InfoPageBackgroundImage, InfoPageShowLiveHelpChatPanel: enableFlg }, OneToOneChat: { IsEnabled: field.data.OneToOneChat,defaultChatMsg: field.data.defaultChatMsg } }
                        }).then(function (doc) {
                            resolve({ status: 200, message: "Plugin Added/Updated" })
                        })
                    } else if (field.data.OneToOneChat != undefined) {
                        con.eventDB.collection(cn).doc('EventInfo').update({
                            Plugins: { OneToOneChat: { IsEnabled: field.data.OneToOneChat,defaultChatMsg: field.data.defaultChatMsg } }
                        }).then(function (doc) {
                            resolve({ status: 200, message: "Plugin Added/Updated" })
                        })
                    }
                    else {
                        enableFlg = field.data.enableDisableFlg == "Disable" ? false : true;
                        con.eventDB.collection(cn).doc('EventInfo').update({
                            Plugins: { SocialWall: { EmbedCode: field.data.embededCode, isEnabled: enableFlg } }
                        }).then(function (doc) {
                            resolve({ status: 200, message: "Plugin Added/Updated" })
                        })
                    }
                }
            });

        })
    },
    cloneEvent(context, field) {
        return new Promise((resolve, reject) => {
            Date.prototype.toJSON = function () { return moment(this).format(); }
            let data = {
                TimeZone: field.data.TimeZone,
                EventStartDate: (field.data.StartDate ? field.data.StartDate.toISOString() : null),
                EventEndDate: (field.data.EndDate ? field.data.EndDate.toISOString() : null),
                EventFullName: field.data.EventFullName,
                EventShortName: field.data.EventFullName
            };

            let key = {
                "instanceId": "OA_UAT",
                "clientId": field.data.ClientId,
                "eventId": field.data.EventId
            }
            context.dispatch('getFirebaseAccessToken').then(accessToken => {
                let headers = {
                    'Authorization': `Bearer ${accessToken}`,
                    "content-type": "application/json"
                }

                let requestData = {
                    "source": "web",
                    "key": key,
                    "data": data,
                    "includeDocs": field.SelectedModules
                }

                axios.post(CloneEventAPI, requestData, { headers: headers }).then((response) => {
                    console.log(response)
                    resolve({ status: 200, message: "event cloned" })
                }).catch((error) => {
                    console.log(error)
                    resolve({ status: 500, message: "event not cloned" })
                })
            })
        })
    },
    updateUserbyId(context, field) {
        return new Promise((resolve, reject) => {
            let headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
            }
            let requestData = {
                "key": {
                    "eventId": field.EventId,
                    "clientId": Session_Client_Id,
                    "instanceId": "OA_UAT"
                },
                "data": field.Userdata
            }
            axios.post(UpdateUserAPI, requestData, { headers: headers }).then(snapShot => {
                if (snapShot.data.status == 0) {
                    resolve({status:200,message:"User Updated"})
                }
                else {
                    resolve({status:500,message:"User Not Updated"})
                }
            }).catch(err=>{ reject(err) })
        })
    },
    getUserDetailbyId(context, UserId) {
        return new Promise((resolve, reject) => {
            let headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
            }
            let requestData = {
                "key": {
                    "eventId": "",
                    "clientId": Session_Client_Id,
                    "instanceId": "OA_UAT"
                },
                "data": {
                    UserId: `${UserId}`
                }
            }
            axios.post(CheckUserValidAPI, requestData, { headers: headers }).then(snapShot => {
                if (snapShot.data.userStatus) {
                    let doc = snapShot.data.result;
                    resolve(doc)
                }
                else {
                    resolve(null)
                }
            }).catch(err=>{ reject(err) })
        })
    },
    getUserEvents(context) {
        return new Promise((resolve, reject) => {
            let headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
            }
            axios.get(UserEventsAPI, { headers: headers }).then(response => {
                if (response.data.status==0 && response.data.customToken) {
                    firebase.auth().signInWithCustomToken(response.data.customToken).then((res) => {
                        firebase.auth().currentUser.getIdToken(true).then(idToken=>{  
                            document.cookie = `AT=${idToken};domain=.e2m.live;path=/`;
                            ls.setSessionUserInfo({Session_AccessToken: idToken});
                            resolve({status:200, Events:response.data.result[0].events})
                        })
                    })
                }
                else {
                    resolve({status:500, Events:[]})
                }
            }).catch(err=>{ reject(err) })
        })
    },
    getFirebaseAccessToken(context) {
        return new Promise((resolve, reject) => {
            let accessToken = ls.getSessionValueByKey("Session_AccessToken")
            resolve(accessToken);
            /*let headers = {
                "content-type": "application/json"
            }
            context.dispatch('getUserDetailbyId', {UserId:Session_UserId}).then( res => {
                let requestData = {
                  "emailId": res.Email,
                  "password": String(res.Password)
                }
                axios.post(FirebaseAuthApi, requestData, { headers: headers }).then((response) => {
                      let accessToken = response.data.accessToken
                      resolve(accessToken)
                })
            })*/
        })
    },
    createJoinURL(context) {
        return new Promise((resolve, reject) => {
            let headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
            }
            let requestData = {
              key: {
                instanceId: "OA_UAT",
                clientId: Session_Client_Id,
                eventId: Session_Event_Id,
              },
              data: {
                userId: Session_UserId,
              },
            };
            axios.post(getJoinURLAPI, requestData, { headers: headers }).then(response => {
                if (response && response.data && response.data.status == 0) {
                  resolve(response.data.joinURL);
                } else {
                  resolve(null);
                }
            }).catch(err=>{ reject("Unable to create join url") })
        })
    },
}